export default {
  loginComponent: {
    login_text_sichern_connect: 'Entrar com Sichern Connect',
    login: {
      copyright: 'Copyright',
      rrhh: 'Recursos Humanos',
      logintext: 'Acessar',
      loadingtext: 'Carregando',
      forgetPassword: 'Esqueceu sua senha?',
      commercialInfo: 'Informação comercial',
      termsAndConditions: 'Políticas de Privacidade',
      help: 'Precisa de ajuda?',
      helpTitle: 'Ajuda',
      helpFaq1:
        'Não consigo acessar a plataforma para consultar meu contracheque',
      helpAnswer11:
        'SICHERN.COM permite uma autogestão, mediante a opção "esqueci minha senha de acesso".',
      helpAnswer12:
        'O sistema enviará ao e-mail cadastrado no sistema as indicações para redifinir senha de acesso ou senha de assinatura.',
      helpAnswer13:
        'Caso não receba o e-mail para redifini-la, entre em contato com o departamento de Recursos Humanos da sua Empresa para eles te assistirem no recupero da senha.',
      helpFaq2: 'Como posso desbloquear o usuário?',
      helpAnswer21:
        'Após vários acessos falidos de login na plataforma, por segurança, o sistema bloqueará o usuário.',
      helpAnswer22:
        'Para desbloquear simplesmente clique na opção "Esqueceu sua senha" e digite o e-mail cadastrado no sistema e seu RG. ',
      helpAnswer23:
        'Caso não receba o e-mail para redifini-la, por favor, entre em contato com o departamento de Recursos Humanos da sua Empresa para eles te assistirem no recupero da senha',
      helpFaq3: 'O sistema é seguro?',
      helpAnswer3:
        'É, ele foi testado com os mais rigorosos métodos de segurança informática, e a comunicação é feita de forma encriptada utilizando o protocolo https, o mesmo que utilizam os bancos, cartões de crédito, sites de pagamentos por Internet etc.',
      requireMoreCharactersPass: 'A senha deve conter mais de 4 caracteres',
      helpFaq4: 'Não consigo acessar meu correio eletrônico?',
      helpAnswer41: 'os correios de usuários são administrados pela empresa.',
      helpAnswer42:
        'Caso tenha algum inconveniente ou não consiga fazer login, entre em contato com o departamento de recursos humanos.',
      helpFaq5: 'Que acontece caso não consiga lembrar minha senha?',
      helpAnswer51:
        'Se esqueceu sua senha, você pode redifini-la de forma rápida e segura.',
      helpAnswer52: 'Clique na opção Esqueceu sua senha?',
      helpAnswer53: 'Digite o e-mail e usuário cadastrado em Sichern.',
      helpAnswer54:
        'Você receberá um e-mail com um link para poder redifinir sua senha.',
      helpAnswer55:
        'Logo de configurada sua nova senha, seu usuário será desbloqueado e você poderá acessar sua conta sem problemas.',
      helpAnswer56:
        'Caso não consiga Redifini-la, por favor, entre em contato com Recursos Humanos de sua Empresa para eles te assitirem no desbloqueio do usuário.',
      helpAnswer511:
        'seu usuário é o seu documento de identidade (DNI, RFC, RUC, CI, RG etc).',
      helpAnswer522:
        'Caso não consiga fazer login, por favor, entre em contato com',
      helpAnswer533: 'indicando o problema e enviando seu número de documento.',
      helpAnswer544:
        'Ou, se preferir, você pode clicar na opção Esqueceu sua senha? na tela de login',
      helpFaq6: 'Como faço login na minha conta?',
      helpAnswer61: 'Digitando seu usuário e senha cadastrados diretamente em',
      helpAnswer62:
        'Tente acessar preferentemente através de um navegador Chrome atualizado, seja com um computador ou com seu telefone móvel.',
      helpAnswer63: 'Também pode acessar através do nosso APP mobile',
      helpAnswer64: 'Importante: verifique ter a nossa versão mais recente',
      helpFaq7: 'Qual é meu Usuário?',
      helpAnswer71:
        'Caso não consiga fazer login, por favor, entre em contato com Recursos Humanos indicando o problema e enviando seu número de documento.'
    },
    forgetPassword: {
      goBack: 'Voltar à tela de login',
      send: 'Enviar',
      mailResendMsg: 'Você não recebeu o e-mail',
      mailResend: 'Reenviar e-mail',
      passwordResetSuccess: 'Foi enviado e-mail com as instruções',
      err400ForgotPass:
        'O usuário / e-mail não foi encontrado por favor, confira os dados inseridos '
    },
    forgetPasswordInvalid: {
      goBack: 'Voltar',
      send: 'Ok',
      passwordResetFalse: 'A combinação de usuário e e-mail não é válida'
    },
    firstLogin: {
      firstLoginText: 'Primeiro acesso',
      changePassSecurity:
        'Por segurança você deve alterar sua senha de acesso ao sistema',
      rememberValidMail:
        'Lembre digitar um e-mail válido, já que ele será verificado durante o processo',
      goBack: 'Voltar ao login',
      send: 'Enviar',
      success: 'A senha foi modificada com sucesso',
      required: 'Este campo é obrigatório',
      notEmail: 'Não tenho conta de e-mail',
      accept: 'Aceito',
      termsAndConditions: 'Termos e condições',
      dataUpdated: 'Dados atualizados corretamente',
      enterMail: 'Digite seu e-mail',
      enterMailMessage:
        'Para manter seu perfil atualizado é necessário que você digite seu e-mail',
      requiredMinCharactersAndOneNumber: 'Mínimo 8 caracteres, 1 número',
      notPersonalInfo: 'Não pode conter informação pessoal do usuário',
      notEasyPassw:
        'A senha não deve ser simples (ej. 12345678, qwerty, admin1234 etc.)'
    },
    blockedUser: {
      title: 'Usuário bloqueado',
      mailResendMsg: 'Você não recebeu o e-mail',
      mailResend: 'Reenviar e-mail',
      msg_1: 'Por segurança, seu usuário foi bloqueado.',
      msg_3: 'Enviamos um e-mail para seu correio com o procedimento a seguir.',
      msg_2:
        'Detectamos que você não conseguiu recuperar sua senha. Enviamos um correio eletrônico com as instruções para gerar uma nova senha.'
    },
    unblockedUser: {
      title: 'Usuário desbloqueado com sucesso',
      msg_1:
        'Seu usuário foi desbloqueado com sucesso. Por favor, tente fazer login novamente na plataforma.'
    },
    validations: {
      emailRules: {
        requireMail: 'O e-mail é obrigatório',
        validMail: 'O e-mail deve ser válido',
        associatedMail: 'O e-mail já está vinculado a um usuário.'
      },
      userRules: {
        requireUser: 'O usuário é obrigatório',
        requireLessCharactersUser:
          'O usuário deve conter menos de 10 caracteres',
        charactersValidation:
          'O campo só permite caracteres alfanuméricos e underline',
        minCharacters: 'O usuário deve conter, no mínimo, {min} caracteres'
      },
      reasonRules: 'O motivo é obrigatório',
      passwordRules: {
        requirePass: 'A senha é obrigatória',
        requireMoreCharactersPass: 'A senha deve conter mais de 8 caracteres'
      }
    },
    languagesVuetify: {
      languages: 'Idioma',
      user: 'Usuário',
      password: 'Senha',
      newPassword: 'Nova senha',
      repeatPassword: 'Confirmar senha',
      inputMail: 'Digite seu e-mail',
      mail: 'e-mail'
    },
    shutdownServer: {
      titleShutdown: 'Não é possível fazer login neste momento',
      subtitleShutdown: 'Por favor, tente novamente mais tarde'
    },
    sso: {
      textButton: 'Utilizar Single Sign-On',
      msgRedirectAuth: 'Verificando...',
      msgRedirectLogin: 'Acessando Sichern',
      msgRedirectErrorLogin:
        'Aconteceu um erro ao verificar o usuário, por favor, tente novamente'
    },
    passwordExpired: {
      newPass: 'Senha',
      repeatPassword: 'Repetir senha',
      go_back_btn: 'Voltar',
      go_to_dashboard: 'Ir para o dashboard',
      update_pass_btn: 'Atualizar',
      success_message: 'Senha atualizada com sucesso',
      pass_expired_message: 'Sua senha expirou. Digite sua nova senha.',
      message_error: {
        error_00019: 'A senha não cumpre com as políticas da empresa',
        error_00024:
          'Houve um problema ao atualizar a senha, tente novamente',
        error_00026: 'Não podem ser repetidas as últimas 3 senhas',
        error_00033: 'A nova senha não pode ser igual à senha atual',
        error_00141: 'A senha não cumpre com as políticas da empresa',
        error_00046:
          'Você já realizou a máxima quantidade de trocas de senha permitidas por dia. Sua conta será restabelecida em 24hs'
      },
      password_validation: {
        required: 'Este campo é obrigatório',
        no_match_pass: 'As senhas inseridas não coincidem',
        min_character_rule: 'Este campo deve conter, no mínimo, 8 caracteres',
        min_number_rule: 'Este campo deve conter, no mínimo, 1 número',
        min_character_info: 'Mínimo 8 caracteres, 1 número'
      },
      password_policies: {
        title: 'A senha deve conter:',
        history_pass: 'Diferente às últimas {input} senhas',
        max_character: 'Máximo {input} caracteres',
        min_character: 'Mínimo {input} caracteres',
        no_expire: 'Não expira',
        expire: 'Expira em {input} dias',
        special_characters_amount: 'No mínimo {input} caracteres especiais',
        min_numbers: 'No mínimo {input} numero',
        min_capital_letter: 'No mínimo {input} maiúscula',
        min_letter: 'Mínimo {input} letra(s)'
      },
      success: {
        success_message: 'Senha atualizada com sucesso',
        pls_go_back: 'Por favor, tente fazer login no sistema.',
        go_back_btn: 'Voltar ao login'
      }
    },
    keyCloak: {
      error: {
        title: 'Erro ao validar a conta',
        body1:
          'Você pode tentar novamente em alguns minutos ou entrar com seu usuário e senha do Sichern.',
        body2:
          'Se o problema continuar, entre em contato com a equipe de Recursos Humanos.',
        footer: 'Código do erro: {errorCode}'
      },
      notLinked: {
        title: 'Sua conta do MiFalabella não está vinculada ao Sichern',
        body:
          'Para continuar, vincule suas contas. Você só precisa fazer isso uma vez e depois poderá acessar o Sichern a partir do MiFalabella. Insira abaixo seu usuário e senha do Sichern.'
      }
    },

    backToPreview: 'Voltar',
    firstToKnow:
      'Para começar você deve conhecer todas as senhas de suas contas. Caso não as conheça, você pode revisar como'
  },
  inicioComponent: {
    hi: 'Olá',
    botText:
      'Olá, {user}!, Sou Vismi, sua atendente virtual e estou aqui para te ajudar com Sichern.',
    initialText1:
      'Em "Tu Recibo" você vai encontrar tudo o relacionado com seu trabalho.',
    initialText2:
      'Você vai poder assinar seu contracheque, atualizar sua informação pessoal e solicitar licenças',
    initialText3: ', tudo aqui.',

    documentsToSign: 'Documentos a serem assinados',
    documentsAvailable:
      '{n} pendente de assinatura | {n} pendentes de assinatura ',
    requestLicense: 'Férias e licenças',
    licensesAvailable: '{n} dia disponível | {n} dias disponíveis',
    licensesRegistered: '{n} dia registrado | {n} dias registrados',
    upload: 'Fotos, arquivos e formulários',
    dashboard: {
      noDashboardTitle: 'Hoje não tem mensagens',
      noDashboardSubtitle:
        'Nesta seção você vai encontrar novidades e notícias.',
      uploadNewNovelty: 'Carregar uma novidade agora'
    },
    failServer:
      'Alguma coisa deu errada no servidor, por favor, tente mais tarde.',
    createSince: 'Criado desde',
    createUntil: 'Criado até',
    notResults: 'Não foram encontrados resultados para sua persquisa',
    infoSearch:
      'Para fazer uma pesquisa você pode inserir Nome, Sobrenome, Código de identificação nos campo de pesquisa ou selecionar uma combinação de filtros.',
    resultSearch: 'Os resultados de sua pesquisa aparecerão aqui',
    advanceSearch: 'Pesquisa Avançada',
    name: 'nome',
    goto: 'Ir a',
    downloadSelected: 'Descarregar Seleção',
    downloading: 'Descarregando...',
    anniversaryDate: '29 de janeiro',
    febraryDate: '11 de fevereiro',
    welcomeAgainMsg: 'Bem-vindo mais uma vez ao portal de funcionários',
    wecomeSichern: 'Bem-vindos ao novo site de Sichern!',
    newInterface: 'Nova interface mais intuitiva',
    newUI: 'Tela de login renovada',
    allDocuments: 'Todos os seus documentos ordenados de forma mais simples',
    number: 'número',
    numbers: 'números',
    upperCase: 'maiúscula',
    upperCases: 'maiúsculas',
    caracter: 'caracter especial',
    caracteres: 'caracteres especiais'
  },
  resetPassComponent: {
    title: 'Recupero de senha',
    subtitle: 'Foi solicitado alterar sua senha de login do sistema',
    labelNewPass: 'Digite uma nova senha',
    labelReNewPass: 'Digite novamente a nova senha',
    successTitle: 'Senha atualizada corretamente',
    successMsg: 'Por favor, tente fazer login novamente',
    successOkBtn: 'Voltar ao login',
    goBackLogin: 'Voltar ao login',
    mailSentRecover: 'Enviamos um e-mail para recuperar sua senha',
    followStepsRecover:
      'Siga o procedimento informado no e-mail para poder gerar uma nova senha',
    minimalPasswordPolicies: 'Minimo 8 caracteres, 1 número',
    recoverPassword: 'recuperar sua senha'
  },
  menuComponent: {
    item0: 'Início',
    item1: 'Documentos',
    item2: 'Solicitar',
    item3: 'Configuração',
    item4: 'Enviar',
    item5: 'Enviar documento',
    modalMessage: 'Tem certeza que deseja cancelar a solicitação?',
    licences: {
      name: 'Férias e Absentismos',
      shortName: 'Absentismos',
      upperCase: 'AUSENTES',
      lowerCase: 'Ausentes',
      loadLicense: 'Carregar Licença'
    },
    managerAd: 'administrador',
    myApps: 'Meus aplicativos',
    sended: 'Envio',
    goToDashboard: 'Ir para o administrador',
    manageAbs: 'Gestão de ausências',
    weekDays: 'Domingo,Segunda,Terça,Quarta,Quinta,Sexta,Sábado',
    seeMissing: 'Ver ausentes',
    presents: 'Presentes',
    back: 'Voltar'
  },
  HeaderComponent: {
    logout: {
      wantLogOutText: 'Tem certeza que quer sair?',
      no: 'Não',
      yes: 'Sim'
    },
    filters: {
      filters: 'Filtros',
      close: 'Fechar'
    },
    help: 'Ajuda',
    search: 'Pesquisar',
    apps: 'Aplicativos',
    company: 'Empresa',
    notifications: 'Notificações',
    accountsLinked: 'Vincule suas contas',
    onlyOneAccount:
      'Você pode vincular todas as suas contas e ter acesso a partir de uma única conta principal.',
    goAccountsLinked: 'Vincular contas',
    sichernTalent: 'Sichern Talent',
    sichernUnite: 'Sichern Unite',
    sichernTime: 'Sichern Time',
    timeManagement: 'Gestão de Tempos',
    omitNotification:
      'Lembre que você sempre pode retomar este processo no botão de notificações, podendo omitir no caso de não querer vincular.',
    noMatchSearch: 'Não há um colaborador que coincida com sua pesquisa',
    timePeriod: 'Período​ de tempo',
    failedAgain: 'Aconteceu um erro, por favor, tente novamente.',
    dates: 'A data de início e finalização não podem ser iguais.',
    success: 'A informação foi enviada corretamente e espera aprovação.'
  },
  DocumentsComponents: {
    title: 'Documentos',
    titleFilter: 'Filtros',
    alerts: {
      blockedDocument: 'Aceitar',
      cantVisualiceDoc: 'Não podemos visualizar seu documento',
      dontPermissionDoc: 'Você não tem permissão para ver este documento'
    },
    statusSigned: {
      signedConformed: 'Assinado conforme',
      signedDisconformed: 'Assinado desconforme',
      pendingApproval: 'Pendente de aprovação',
      noRequiredSignature: 'Não precisa assinatura',
      rejected: 'Rejeitado',
      noSigned: 'Não assinado'
    },
    searchDocuments: 'Pesquisador de Documentos',
    pdfFile: 'Archivo PDF',
    xmlFile: 'Archivo XML',
    filterBy: 'Filtrar por:',
    signedSince: 'Assinado desde',
    signedUntil: 'Assinado até',
    legal: 'Legais',
    progresive: 'Progressivos',
    documentSended: 'Documento Enviado',
    account: 'Conta Salário',
    ctsAccount: 'Conta CTS',
    failSaved: 'Aconteceu um erro ao processar o guardado',
    previewDocument: 'Vista prévia do documento',
    fileTitle: 'Arquivo',
    connectorFile: 'no total'
  },
  DownloadAllDocuments: {
    downloadAll: 'Descarregar',
    downloadAllDocuments: 'Descarregar Tudo',
    downloadDocuments: 'Descarregar Documentos',
    preparingDocuments: 'Estamos preparando seus documentos',
    sendYouMail: 'Vamos enviar um e-mail para você poder descarregá-lo',
    youWantDownloadAllDocs: 'Quer descarregar todos os,',
    selectedDocuments: 'documentos?',
    sendToLinkMail: 'Vamos enviar um link de descarga ao seguinte e-mail',
    messageWarning:
      'Recomendamos que seja um e-mail pessoal. Quando acessar a plataforma, vamos solicitar as credenciais.',
    messageWarningNoEmail:
      'Você não tem um e-mail cadastrado para continuar com a descarga, faça o cadastro no seu perfil',
    sendToLinkMailInMinutes:
      'Nos próximos minutos você vai receber um link no seu e-mail para fazer a descarga',
    cancel: 'Cancelar',
    yesDownload: 'Sim, descarregar',
    understood: 'Entendi',
    downloadInProgress: 'Uma descarga está em processo.',
    pleaseTryAgain: 'Tente novamente em alguns minutos.',
    discardDownload: 'Deseja descartar e fazer uma nova descarga?',
    downloadModal: {
      title: 'Descarga de documentos',
      titleChangeCompany: 'Trocar empresa',
      messageInitialDownload:
        'A descarga de documentos se iniciou de forma automática.',
      problemWithDownloadLink: 'Caso tenha problemas com a descarga',
      clickHere: 'clique aqui',
      expiredDownload: 'A descarga de seus documentos expirou',
      retryDownload: 'Quer tentar descarregá-los novamente',
      iframeRetryDownload: 'Tente novamente, clicando no botão Descarregar',
      messageRedirect:
        'Estamos te redirigindo para a seguinte empresa, por favor, aguarde uns minutos'
    }
  },
  homeComponent: {
    title: 'Home',
    sections: {
      documents_to_sign: 'Documentos a serem assinados',
      send_signed_document: 'Envio de documento assinado',
      send_document_email: 'Enviar documento por e-mail',
      valid_email_requerid: 'O e-mail é obrigatório e deve ser válido',
      send_valid_email:
        'Ao assinar você estará enviando o documento ao e-mail selecionado',

      vacations_licenses: 'Férias e Absentismos',
      documentsManagement: 'Gestão de documentos',
      upload_file: 'Enviar documento',
      self_service: 'Atualização de dados',
      eform_complete: 'Preencher Formulário',
      subtitles: {
        sub_documents_sing: 'Ir para meus documentos',
        sub_vacations_licences: 'Ir para minhas licenças',
        sub_self_service: 'Modifique seus dados na plataforma',
        documentsManagement: 'Envio e solicitação de documentação'
      }
    },
    homeContents: {
      title: 'Assinatura de contracheques',
      next_page: 'Página seguinte',
      prev_page: 'Página anterior'
    },
    birthdays: {
      title: 'Aniversários',
      no_events: 'Sem eventos',
      before_yesterday: 'Anteontem',
      yesterday: 'Ontem',
      today: 'Hoje',
      tomorrow: 'Amanhã',
      after_tomorrow: 'Depois de amanhã',
      next: 'Próximos'
    },
    recentHired: {
      title: 'Ingressos do mês',
      no_events: 'Não há ingressos este mês',
      show_more: 'Mostrar mais',
      show_minus: 'Mostrar menos',
      teammate: 'Colegas de trabalho'
    },
    absentUsers: {
      title: 'Ausências',
      emptyMessage: 'Não tem ausências no seu setor hoje'
    },
    anniversaries: {
      title: 'Aniversários'
    },
    linkUserLogin: {
      title: 'Vinculação de contas',
      error: 'Aconteceu um erro inesperado, por favor, tente novamente',
      byEmail: {
        subtitle: 'Atualização de e-mail',
        info:
          'Você está pronto para vincular as contas com este e-mail <strong>{mail}</strong> <br/> Quer continuar?',
        ok: 'Sim, vincular contas',
        cancel: 'Cancelar',
        success_message:
          'e-mail atualizado corretamente<br/>As contas foram vinculadas',
        success_message_2: 'Por favor, faça login novamente',
        go_login: 'Voltar ao login',
        finish: 'Vinculação terminada',
        no_success: 'Nenhuma conta será vinculada, tenha um bom dia.',
        redirect_home: 'Será redigido ao home'
      },
      byPass: {
        subtitle: 'Nova senha',
        info:
          'Para continuar com a vinculação de contas, é necessário criar uma nova senha',
        newPass: 'Nova senha',
        repeatPass: 'Repita a senha',
        successMessage: 'Você alterou sua senha<br/>As contas foram vinculadas'
      },
      tokenExpired: {
        info_1: 'Expirou a solicitação para vincular as contas',
        info_2: 'Por favor, faça login para gerar outra',
        go_login: 'Login'
      }
    },
    linkUserModals: {
      later: 'Em outra hora',
      title: 'Vincular contas',
      ok: 'Entendi',
      byPassword: {
        title:
          'Detectamos que você tem uma outra conta associada a este e-mail. Quer unificá-las?',
        subtitle_1:
          'Ao clicar no botão “Vincular conta” enviaremos um e-mail a <strong>{mail}</strong> para você iniciar a vinculação',
        subtitle_2:
          'Para vincular as contas, vamos te pedir gerar uma nova senha',
        usersToLink: 'Contas a vincular',
        linkAccount: 'Vincular conta',
        mailSent: 'E-mail enviado',
        mailSentMessage:
          'Enviamos um e-mail a {mail} para continuar com os dados para vincular sua conta.',
        resendMail: 'Reenviar e-mail'
      },
      byEmail: {
        step1: {
          title:
            'Detectamos que seu usuário tem contas que podem ser vinculadas',
          subtitle_1: 'Você quer vincular seu usuário com esta empresa?',
          info:
            'Ao vincular as contas, seu usuário e senha para acessar a plataforma vão ser os mesmos e isso vai facilitar o acesso às diferentes empresas nas que você trabalhou. Vai poder fazer login em uma ou outra empresa com as mesmas credenciais.',
          linkAccount: 'Vincular conta'
        },
        step2: {
          subtitle_1:
            'Selecione um e-mail para estabelecer como predeterminado para o login do sistema',
          subtitle_2:
            'Enviaremos um e-mail a <strong>{mail}</strong> para você confirmar a vinculação de contas',
          sendEmail: 'Enviar e-mail'
        },
        success: {
          title: 'Vinculação de contas',
          subtitle_1:
            'Enviamos um e-mail para sua conta <strong>{mail}</strong> para você finalizar a vinculação',
          subtitle_2: 'Não recebi o e-mail ',
          rresendEmail: 'Reenviar e-mail'
        }
      }
    },
    downloadLinkMobile: {
      availableApp: 'Temos uma nova atualização do app Sichern disponível.',
      authMessage:
        'Agora vai poder fazer login em Sichern utilizando a impressão digital ou o rosto caso seu dispositivo o permita.',
      download: 'Download on the',
      appStore: 'App Store',
      getIt: 'GET IT ON',
      googlePlay: 'Google Play'
    },
    alert: {
      falabella: {
        fail: {
          title: 'Houve um problema ao vincular as contas.',
          subtitle:
            'Tente novamente depois de uns minutos. Se o problema continuar, entre em contato com a equipe de RH.'
        },
        success: {
          title: 'Conta vinculada com sucesso',
          subtitle:
            'Agora você pode acessar sichern através da conta de Mifalabella'
        }
      }
    },
    delete: 'Apagar',
    selected: 'selecionados',
    deleteSelected: 'Apagar {lngt} selecionados',
    visualizacionHere: 'Aqui vai visualizar',
    allTxt: {
      allTxt1: 'Todos os',
      allTxt2: 'Todas as'
    },
    addeds: {
      addeds1: 'adicionados',
      addeds2: 'adicionadas'
    },
    allAddeds1: 'Todos os {dni} adicionados',
    allAddeds2: 'Todas as {cis} adicionadas',
    sector: 'Setores',
    location: 'Localização',
    noForm: 'Não tem formulários disponíveis para autogestão',
    men: 'Homem',
    women: 'Mulher',
    noBinary: 'Não Binário'
  },
  searchComponent: {
    sections: {
      title: 'Pesquisa de funcionários'
    },
    download: {
      text_filter_by_page: 'Mostrar',
      employee_export_results: 'Exportar Resultados',
      employee_exporting_results: 'Exportando...'
    },
    alerts: {
      modal_reset_pass_correct: 'E-mail Enviado',
      modal_reset_pass_incorrect: 'Erro ao enviar e-mail',
      modal_reset_pass_incorrect_change: 'Erro ao alterar o e-mail',
      button_confirm: 'Aceitar'
    },
    advanceSearch: {
      text_sector: 'Setor',
      text_locacion: 'Localização',
      all_locacion: 'TODOS',
      all_sector: 'TODOS'
    },
    title: 'Pesquisa',
    search: 'Critérios de pesquisa',
    form_select: 'Selecione...',
    not_founded: 'Não encontrado',
    max_elements: 'Máximo um elemento selecionado',
    employee_result: 'Resultados',
    employees_list_result: 'Lista de funcionários',
    employees_title: 'Gestão de funcionários',
    employees_list_search_title_error: 'Isto é um deserto!',
    employees_list_search_desc_error:
      'Sinto muito, mas não encontramos nenhum resultado com os critérios de pesquisa selecionados. Por favor, tente com uma combinação diferente.',
    employees_list_search_title:
      'Os resultados de sua pesquisa serão mostrados aqui',
    employees_list_search_desc:
      'Para realizar uma pesquisa você pode inserir Nome, Sobrenome, Documento de identidade ou e-mail do funcionário no campo de pesquisa ou selecionar uma combinação de filtros.',
    searchfor: 'Pesquisar',
    ob_load_employees: 'Carga de funcionário',
    home_button_add: 'Administrar Funcionários',
    ob_masive_load_employees: 'Carga massiva de funcionários',
    search_text_select_cargo: 'TODOS',
    search_text_1: 'Pesquisa por:',
    search_text_1_1: 'Documento de identidade, Nome, Sobrenome ou e-mail',
    search_text_1_2: 'Cadastro',
    search_text_1_3: 'Pesquisa Avançada',
    search_text_2: 'Estado Funcionário',
    search_text_2_1: 'Onboarding',
    search_text_2_2: 'Ativo',
    search_text_2_3: 'Inativo',
    search_text_3: 'Tipo de Perfil',
    search_text_3_1: 'RH',
    search_text_3_2: 'Funcionário',
    search_text_6: 'Módulo de Licenças',
    search_text_6_1: 'Aprovador',
    search_text_7: 'Ingresso',
    search_text_7_1: 'Não ingressaram',
    search_text_8: 'Setor e Locação',
    search_text_9: 'Selecionado',
    search_text_10: 'Data de contratação',
    search_text_11: 'Data de desvinculação',
    search_text_date_placeholder: 'Selecione um período de datas',
    search_folder_tooltip: 'Configurar pastas',
    search_reset_pass_tooltip: 'Restaurar Senha',
    fileNumber: 'Número de cadastro',
    fileNumberInvalid: 'Valor inválido, campo numérico',
    listEmployees: {
      ob_down_employees: 'Baixa massiva',
      tooltip_cargo:
        'Cargo que desempenha o funcionário na empresa. Atualizável de forma massiva por CSV em "Carga massiva" ou de forma individual no detalhe do funcionário',
      tooltip_report:
        'Jefe directo.  Atualizável de forma massiva por CSV em "Carga massiva" ou de forma individual em "Cadastro do funcionário"'
    },
    head_text_table_list_1: 'Nome',
    head_text_table_list_2: 'Ultima modificação',
    head_text_table_list_3: 'Status',
    head_text_table_search_1: 'Nome e Sobrenome',
    head_text_table_search_2: 'e-mail',
    head_text_table_search_3: 'Documento de identidade',
    head_text_table_search_4: 'Cadastro',
    head_text_table_search_5: 'Status',
    head_text_table_search_6: 'Data de contratação',
    text_table_status_1: 'Ativar',
    text_table_status_2: 'Desativar',
    onboarding_label_by_page: 'Mostrar',
    employees_list_modal_reset_subtitle:
      'Será enviado um link ao usuário para restaurar a senha',
    employee_export_results: 'Exportar Resultados',
    employee_exporting_results: 'Exportando...',
    employee_activate_selection: 'Ativar Seleção',
    employee_confirm: 'Aceitar',
    employee_edit_error: 'Alguma coisa deu errada!',
    employee_edit_success: 'Usuário modificado com sucesso',
    employees_list_modal_folder_title: 'Permissão a pastas',
    search_folder_placeholder: 'Não há mais pastas',
    employees_list_modal_folder_empty: 'Não tem pastas designadas',
    header_top_bar_modal_save: 'Salvar',
    employees_list_modal_folder_subtitle: 'Pastas designadas',
    cancel: 'Cancelar',
    login_send: 'Enviar',
    ei_titleList_text_2_2: 'e-mail',
    position_position_ubication: 'Cargo',
    report_to_position_ubication: 'Reporta a',
    error_position_not_found: 'Cargo não disponível',
    select_folders: 'Selecionar pastas',
    select_location: 'Selecione um setor',
    select_position: 'Selecione um cargo',
    select_section: 'Selecione uma localização',
    search_combo_reporta_a: 'Faça uma pesquisa...',
    empty_list: 'Lista vazia',
    show_password: 'Mostrar senha',
    select_options: 'Selecione uma opção',
    load_photo: 'Carregar foto'
  },
  Errors: {
    401: {
      title_401: 'Não possui autorização',
      sub_title_401: 'Sua sessão expirou. Você deve começar de novo.'
    },
    403: {
      title_403: 'Sinto muito, mas você não tem acesso a este site.',
      sub_title_403:
        'Se você não for administrador pode ir para o site de funcionário ou voltar para o início.'
    },
    404: {
      title_404: 'Sinto muito, mas o site não foi encontrado',
      sub_title_404: 'Afortunadamente você pode pesquisar novamente no início'
    },
    500: {
      title_500: 'Não foi possível gerar o token'
    },
    rrhhHandler: {
      notPermission: 'Você não tem permissão para acessar esta seção',
      buttonGoToAdmin: 'Ir para o administrador de RH'
    }
  },
  errorReference: {
    SICHERN_PEOPLE_EMPLOYEE_CONFLICT:
      'Detectamos usuários duplicados em Sichern People. Por favor, entre em contato com seu administrador.',
    SICHERN_PEOPLE_NOT_IMPLEMENTED:
      'Esta funcionalidade não está disponível em Sichern People.',
    SICHERN_PEOPLE_EMPLOYEE_NOT_EXISTS:
      'Não pudemos te encontrar como funcionário em Sichern People. Por favor, entre em contato com seu administrador.',
    SICHERN_PEOPLE_GET_HOLIDAYS_MODEL_NOT_FOUND:
      'O funcionário não configurou um modelo de férias. Por favor, entre em contato com suporte.',
    SICHERN_PEOPLE_GET_HOLIDAYS_BALANCE_NOT_FOUND:
      'O funcionário não tem férias configuradas.',
    SICHERN_PEOPLE_GET_ABSENCE_MODEL_NOT_FOUND:
      'O funcionário não configurou um modelo de ausências. Por favor, entre em contato com suporte.',
    SICHERN_PEOPLE_GET_ABSENCE_BALANCE_NOT_FOUND:
      'Não foi encontrado o balanço para esta licença. Por favor, entre em contato com o administrador de Sichern People ou com suporte.',
    SICHERN_PEOPLE_PUT_APPROVE_ABSENCE_BAD_REQUEST_AbsenceNotExists:
      'Não é possível encontrar a licença em Sichern People, por favor, entre em contato com seu administrador.',
    SICHERN_PEOPLE_PUT_APPROVE_ABSENCE_ERROR:
      'Não foi possível processar a solicitação neste momento, por favor, tente mais tarde.',
    SICHERN_PEOPLE_PUT_APPROVE_ABSENCE_BAD_REQUEST:
      'Houve um problema ao processar a solicitação.',
    SICHERN_PEOPLE_PUT_APPROVE_ABSENCE_BAD_REQUEST_StatusNotAllowed:
      'A licença já foi processada.',
    SICHERN_PEOPLE_PUT_REJECT_ABSENCE_NOT_FOUND:
      'Não foi possível encontrar a licença em Sichern People, por favor, entre em contato com seu administrador.',
    SICHERN_PEOPLE_PUT_REJECT_ABSENCE_ERROR:
      'Não foi possível processar a solicitação neste momento, por favor, tente mais tarde.',
    SICHERN_PEOPLE_PUT_REJECT_ABSENCE_BAD_REQUEST:
      'Houve um problema ao processar a solicitação.',
    SICHERN_PEOPLE_PUT_REJECT_ABSENCE_BAD_REQUEST_StatusNotAllowed:
      'A licença já foi processada.',
    SICHERN_PEOPLE_HOLIDAYS_NUMBER_OF_DAYS_TO_REQUEST_BAD_REQUEST:
      'Não é possível processar a solicitação porque você está tentando solicitar mais dias dos disponíveis.',
    SICHERN_PEOPLE_HOLIDAYS_NUMBER_OF_DAYS_TO_REQUEST_BAD_REQUEST_BeginningOfAbsenceOnAHoliday:
      'Não é possível iniciar a ausência em dia feriado/festivo',
    SICHERN_PEOPLE_POST_ABSENCE_BAD_REQUEST_AnnualQuotaNotValid:
      'A quantidade de dias solicitados ultrapassa o limite anual.',      
    SICHERN_PEOPLE_POST_BAD_REQUEST_BeginningOfAbsenceOnAHoliday:
      'Não é possível iniciar a ausência em dia feriado/festivo',
    SICHERN_PEOPLE_POST_BAD_REQUEST_AntiqueCountNotValid:
      'A data de início ultrapassa o limite de antiguidade de carga permitido para este tipo de ausência.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_DaysOverlapExists:
      'Foi detectada outra ausência entre as datas da solicitação.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_AbsenceTypeNotAllowed:
      'O tipo de ausência selecionada não é válida.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_invalidDatesForPartialAbsence:
      'Período de datas inválidas para ausência parcial. Deve iniciar e finalizar no mesmo dia',
    SICHERN_PEOPLE_POST_BAD_REQUEST_InvalidDateRange:
      'As datas ingressadas não são válidas',
    SICHERN_PEOPLE_POST_BAD_REQUEST_NumberOfHoursIsInvalid:
      'Período de horas é inválido para ausência parcial.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_PartialAbsenceNotSupported:
      'Não é permitido o uso de ausência parcial.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_OrganizationModelNotFound:
      'O usuário não possui um modelo organizacional em Sichern People.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_ProcessedAbsenceExists:
      'Atenção! Esta ausência foi processada. Não se permite modificar ou eliminar.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_AbsenceStatusNotValidForOperation:
      'A ação não pode ser executada pelo estado atual da ausência.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_RequestedDaysIsNotMultipleOf:
      'A quantidade de dias solicitados não cumpre com o múltiplo requerido',
    SICHERN_PEOPLE_POST_BAD_REQUEST_AbsenceTypeNotValidForContinuity:
      'O tipo de ausência não é elegível para continuidade.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_AbsenceTypeIsNotActive:
      'O tipo de ausência não se encontra ativa. Consulte com a administração.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_InvalidAtrributes:
      'Foram detectados atributos inválidos na solicitação, por favor entre em contato com o administrador de Sichern People.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_GenderNotValid:
      'A ausência selecionada não está disponível para o gênero do colaborador.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_EventsMaxNumberNotValid:
      'Esta licença ultrapassou a quantidade de solicitações máximas permitidas conforme a política',
    SICHERN_PEOPLE_POST_BAD_REQUEST_MonthlyQuotaNotValid:
      'Não é possível gerar a solicitação, você ultrapassou a quantidade de solicitações no mês.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_WorkSeniorityNotValid:
      'Não é possível solicitar esta ausência já que o usuário não cumpre com a antiguidade mínima requerida.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_ErrorCreatingReviewStatus:
      'Falhou a solicitação, não foi possível gerar a situação de revista para esta ausência.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_DateFromMondayNotValid:
      'A solicitação deve iniciar numa segunda-feira',
    SICHERN_PEOPLE_POST_BAD_REQUEST_MinimumNumberOfDaysNotValid:
      'Não é possível processar a solicitação já que não cumpre com o mínimo de dias requerido por política.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_CertificateIsRequired:
      'O atestado é obrigatório para solicitar esta ausência.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_AntiqueCountNotValid:
      'A data de início ultrapassa o limite de antiguidade de carga permitido para este tipo de ausência.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_begginingOfAbsenceOnAHoliday:
      'A ausência não pode iniciar nun dia feriado, poderá iniciar a partir do próximo dia útil.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_DateFromMondayNotValid:
      'A solicitação deve iniciar numa segunda-feira',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_DaysOverlapExists:
      'Foi detectada outra ausência entre as datas da solicitação.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_MinimumNumberOfDaysNotValid:
      'Não é possível procesar a solicitação já que não cumpre com o mínimo de dias requerido por política.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_ExtendPeriodNotValid:
      'A data final da solicitação deverá ser anterior, pois ultrapassa o número de meses de prorrogação de período permitido, conforme configuração do modelo de férias.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_BeginningOfAbsenceOnAHoliday:
      'Não é possível iniciar a ausência em dia feriado/festivo',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_AnticipatePeriodNotValid:
      'O período de adiantamento não é válido.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_InsufficientBalanceError: 
      'Saldo insuficiente. O saldo está vencido.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_NumberOfDaysRequestByLimitNotValid: 'Não é possível processar a solicitação porque você está tentando solicitar mais dias do que os disponíveis.',
    SICHERN_PEOPLE_POST_HOLIDAYS_ERROR:
      'Erro na hora de solicitar esta licença. Por favor, entre em contato com suporte.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_MaternityAbsenceNotFound:
      'Não é possível solicitar uma prorrogação da licença já que não existe uma licença por maternidade prévia registrada',
    SICHERN_PEOPLE_POST_BAD_REQUEST_InvalidIdCertificate:
      'Não é possível solicitar a licença com o arquivo em anexo. O identificador do arquivo é inválido para Sichern People.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_AbsenceTotalDaysExceedsEventsMaxNumber:
      'A quantidade de dias solicitados ultrapassa o máximo permitido por ausência.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_InsufficientBalanceError:
      'Não tem saldo suficiente para fazer a solicitação.',
    SICHERN_PEOPLE_ABSENCE_NUMBER_OF_DAYS_TO_REQUEST_BAD_REQUEST:
      'Não foi possível calcular o número de dias a serem descontados. Por favor, entre em contato com suporte.',
    SICHERN_PEOPLE_ABSENCE_NUMBER_OF_DAYS_TO_REQUEST_ERROR:
      'Erro ao calcular o número de dias a serem descontados. Por favor, entre em contato com suporte.',
    SICHERN_PEOPLE_HOLIDAYS_NUMBER_OF_DAYS_TO_REQUEST_ERROR:
      'Erro ao calcular o número de dias a serem descontados. Por favor, entre em contato com suporte.',
    SICHERN_PEOPLE_POST_ABSENCE_ERROR:
      'Erro na hora de solicitar esta licença. Por favor, entre em contato com suporte.',
    SICHERN_PEOPLE_POST_ABSENCE_BAD_REQUEST:
      'Houve um problema ao processar a solicitação',
    SICHERN_PEOPLE_POST_ABSENCE_BAD_REQUEST_DaysOverlapExists:
      'Foi detectada outra ausência entre as datas da solicitação.',
    SICHERN_PEOPLE_POST_ABSENCE_BAD_REQUEST_AbsenceTotalDaysExceedsEventsMaxNumber:
      'A quantidade de dias solicitados ultrapassa o máximo permitido por ausência.',
    SICHERN_PEOPLE_POST_ABSENCE_BAD_REQUEST_AntiqueCountNotValid:
      'A data de início ultrapassa o limite de antiguidade de carga permitido para este tipo de ausência.',
    SICHERN_PEOPLE_POST_ABSENCE_BAD_REQUEST_MonthlyQuotaNotValid: 'Não é possível gerar a solicitação, você ultrapassou a quantidade de solicitações no mês.',
    SICHERN_PEOPLE_PUT_APPROVE_HOLIDAYS_ERROR:
      'Não foi possível a solicitação neste momento, por favor, tente mais tarde.',
    SICHERN_PEOPLE_PUT_APPROVE_HOLIDAYS_NOT_FOUND:
      'Não foi possível encontrar a licença em Sichern People, por favor, entre em contato com seu administrador.',
    SICHERN_PEOPLE_PUT_APPROVE_HOLIDAYS_BAD_REQUEST:
      'Houve um problema ao processar a solicitação',
    SICHERN_PEOPLE_PUT_APPROVE_HOLIDAYS_BAD_REQUEST_StatusNotAllowed:
      'A licença já foi processada',
    SICHERN_PEOPLE_PUT_REJECT_HOLIDAYS_NOT_FOUND:
      'Não é possível encontrar a licença em Sichern People, por favor, entre em contato com seu administrador.',
    SICHERN_PEOPLE_PUT_REJECT_HOLIDAYS_ERROR:
      'Não foi possível processar a solicitação neste momento, por favor, tente mais tarde.',
    SICHERN_PEOPLE_PUT_REJECT_HOLIDAYS_BAD_REQUEST:
      'Houve um problema ao processar a solicitação.',
    SICHERN_PEOPLE_PUT_REJECT_HOLIDAYS_BAD_REQUEST_StatusNotAllowed:
      'A licença já foi processada.',
    SICHERN_PEOPLE_GET_HOLIDAYS_TIME_REGIME_NOT_FOUND:
      'O funcionário não tem designado um regime de tempo.',
    SICHERN_PEOPLE_POST_UPLOAD_FILE_ERROR:
      'Não é possível solicitar a licença com o arquivo em anexo. Não foi possível enviar o arquivo para Sichern People',
    SICHERN_PEOPLE_POST_UPLOAD_FILE_CREATION_ERROR:
      'Não é possível solicitar a licença com o arquivo em anexo. Não foi possível criar o arquivo e enviá-lo para Sichern People',
    UNAUTHORIZED_USER_TO_CREATE_LICENCE:
      'Usuário não autorizado para solicitar licença',
    USER_NOT_FOUND_EXCEPTION: 'Usuário não encontrado',
    USER_LINK_EMAIL_WRONG_CODE: 'Codigo inválido, por favor, tente novamente.',
    SYSTEM_API_PARAMETER_IS_EMPTY: 'Falta enviar um parâmetro.',
    SYSTEM_API_PARAMETER_NOT_EXPECTED: 'Parâmetro não esperado.',
    USER_LINK_INVALID_CANDIDATE: 'User inválido para vincular',
    USER_LINK_TOKEN_EXPIRED: 'Token expirado',
    USER_LINK_WRONG_PASSWORD: 'Senha inválida',
    USER_LINK_PASSWORD_NOT_VERIFIED: 'Senha não verificada',
    USER_LINK_EMAIL_TOKEN_EXPIRED: 'Token para validar e-mail expirado',
    USER_LINK_EMAIL_LAST_ATTEMPT:
      'Você possui mais uma tentativa! Se não lembrar a senha, pode recuperá-la no login e retomar logo a vinculação. Após a próxima tentativa falida você não poderá vincular esta conta.',
    USER_LINK_LAST_ATTEMPT: 'Última tentativa para inserir o código',
    USER_LINK_LAST_ATTEMPT_FAILED:
      'Última tentativa falida para inserir o código, não vai ser possível vincular a última conta',
    COULD_NOT_SEND_MAIL: 'O e-mail não pôde ser enviado',
    LICENSE_TYPE_NOT_FOUND: 'Tipo de licença não encontrada',
    LICENSE_MODULE_NOT_ACTIVE: 'Módulo de licença não ativo',
    SYSTEM_API_WRONG_DATA_TYPE: 'Tipo incorreto de userId',
    LICENSE_MANAGER_REQUEST_ERROR: 'Houve um erro na solicitação',
    LICENSE_MANAGER_APPROVER_IS_NOT_DEFINED: 'O aprovador não está definido',
    LICENSE_MANAGER_APPROVER_NOT_FOUND: 'Aprovador não encontrado',
    LICENSE_MANAGER_FILE_NUMBER_NOT_MATCH_EXCEPTION:
      'O número de cadastro do manager não coincide com o do aprovador',
    LICENSE_MANAGER_CREATE_ERROR: 'Erro na solicitação',
    HOLIDAY_PERIODS_NOT_FOUND: 'Períodos de férias não encontrados',
    SICHERN_PEOPLE_INTEGRATION_NOT_ACTIVE:
      'Integração com Sichern People não ativa',
    USER_ENTITY_ID_NOT_FOUND: 'ID de entidade do usuário não encontrado',
    desconocido: 'Erro desconhecido',
    err500: 'Não foi possível gerar o token',
    err400: 'Não foi possível enviar a consulta',
    err404:
      'Não se encontrou ou não está configurado corretamente o tipo de documento. (tipo: Genérico)',
    errorImageSize: 'Tamanho ou formato inválido',
    errAccessRRHH: 'Não possui perfil de funcionário ou de aprovador',
    RequestStartDayNotAllowed: 'O dia de início da licença não é válido',
    RequestEndDayNotAllowed: 'O dia de fim da licença não é válido',
    EmployeeMustHaveAMinimumSeniorityForHolidayRequest: 'Você não tem a antiguidade necessária para solicitar férias',
    BeginningOfAbsenceOnAHoliday: 'O dia de início da licença não é válido',
    EndOfAbsenceOnAHoliday: 'O dia de fim da licença não é válido',
    '012': 'usuário e/ou senha incorreta',
    '00001': 'Usuário e/ou senha incorretos.',
    '00002': 'Erro interno',
    '00003': 'Houve um problema, por favor, faça o login novamente',
    '00009': 'Não possui permissão para acessar nesta seção',
    '00015': 'Primeiro acesso é requerido.',
    '00016': 'Primeiro acessó já realizado.',
    '00017': 'Alguma coisa deu errada.',
    '00018': 'Usuário bloqueado.',
    '00019': 'A senha inserida não cumpre com as políticas de segurança.',
    '00020': 'Token inválido.',
    '00021': 'Erro na geração do token.',
    '00022': 'Erro no registro do token.',
    '00023': 'Cancelamento do registro do token falido',
    '00026': 'A senha já foi utilizada',
    '00028': 'Não possui este tipo de aplicativo',
    '00029': 'O ID do documento não foi definido',
    '00030': 'A pasta não existe',
    '00033': 'A nova senha não pode ser igual à senha atual',
    '00034': 'Senha de verificação de identidade incorreta',
    '00031': 'Erro interno',
    '00036': 'Não foi possível registrar o primeiro início de sessão',
    '00037': 'O ID do aplicarivo não foi definido',
    '00038': 'O ID do documento não foi definido',
    '00039': 'Insira uma senha para assinar',
    '00040': 'Não possui permissão para realizar esta ação',
    '00041': 'Não pode assinar contracheques de uma empresa anterior',
    '00042': 'A senha é incorreta',
    '00043': 'O documento não existe',
    '00044': 'Não tem permissão para visualizar o documento',
    '00045':
      'Erro ao assinar o documento. O certificado para assinar carece de dados',
    '00046': 'Ultrapassou a quantidade de alterações de senha',
    '00047': 'Não foi possível carregar a imagem',
    '00048': 'Formato de imagem inválido',
    '00049': 'A imagem não pode ser menor ou igual a 40px por 40px',
    '00050': 'Carregue uma imagem para recortar',
    '00051': 'Digite o largo que terá a imagem',
    '00052': 'Digite o alto que terá a imagem',
    '00053': 'Digite a posição inicial do ângulo X',
    '00054': 'Digite a posição inicial do ângulo Y',
    '00055': 'Os dados não puderam ser salvos',
    '00056': 'Verifique a imagem',
    '00057': 'Este documento não pode ser visualizado',
    '00069': 'A senha é obrigatória para atualizar a informação',
    '00070': 'O e-mail não foi definido',
    '00071': 'Senha incorreta',
    '00072': 'O usuário não foi identificado',
    '00073': 'Não possui permissão para modificar o usuário',
    '00074': 'e-mail incorreto',
    '00076': 'A senha deve ter entre 8 e 32 caracteres',
    '00078': 'Erro ao obter a configuração da empresa',
    '00079': 'Não tem permissão para realizar esta ação',
    '00080': 'Erro ao obter a configuração da empresa',
    '00081': 'Erro ao obter a configuração da licença',
    '00082': 'Erro ao obter a aprovação dos usuários',
    '00083': 'O usuário não pode solicitar uma licença',
    '00084': 'Erro na entrada de datas',
    '00085': 'Erro de critérios ingressados, verificar',
    '00086': 'Erro de formato de data, é requerido dd/mm/aa',
    '00087': 'O id da licença não foi definido',
    '00088': 'Erro ao cancelar a licença',
    '00089':
      'Aconteceu um problema ao criar a solicitação. Por favor, tente novamente',
    '00094': 'Erro no certificado de assinatura',
    '00095': 'Deve inserir uma ação.',
    '00096':
      "Ação não válida! As ações disponíveis são: 'info', 'salvar', 'solicitar'",
    '00097': 'O usuário não foi definido.',
    '00098': 'O e-mail não foi definido.',
    '00099':
      'Não foi possível identificar o usuário, por favor, entre em contato com RH de sua empresa.',
    '00100': 'Não pudemos criar o hash para redifinir a senha.',
    '00101': 'Digite uma nova senha.',
    '00102': 'Repita a nova senha.',
    '00103': 'As senhas não coincidem.',
    '00104': 'Por favor, redifina a senha novamente',
    '00105': 'Erro de autentificação',
    '00106': 'Ação inválida',
    '00107': 'Deve inserir um usuário.',
    '00108': 'Não foi inserido um usuário ou correio',
    '00109': 'Digite o código de ativação',
    '00110': 'Código de ativação incorreto',
    '00111': 'A senha deve ser mais forte',
    '00112': 'A senha não deve conter informação pessoal',
    '00113': 'A senha deve ter entre 8 e 32 caracteres',
    '00114':
      'Você ultrapassou o máximo de alterações de senha permitidos, por favor, entre em contato com um administrador',
    '00115': 'Não foi possível atualizar a senha do cadastro.',
    '00116': 'Não pode repetir a anterior',
    '00117': 'A senha não pode conter informação pessoal do usuário',
    '00118':
      "Os campos 'Usuário', 'Nome' e 'Sobrenome' são necessários para validar a senha",
    '00119': 'A senha deve ser de maior complexidade',
    '00120': 'A empresa não pode ser nula',
    '00121': 'A senha e o correio não podem estar vazios',
    '00122': 'O usuário não pode ser nulo',
    '00123': 'O nome não pode ser nulo',
    '00124': "O sobrenome não pode ser nulo'",
    '00125': 'O RG não pode ser nulo',
    '00126': 'O CPF não pode ser nulo',
    '00127': 'O RG já existe',
    '00128': 'O CPF já existe',
    '00129': 'O e-mail já existe',
    '00130': 'O nome de usuário já existe',
    '00131': 'O número de cadastro já existe',
    '00132': 'A data de contratação não pode ser menor à data de nascimento',
    '00133':
      'Deve existir uma diferença maior a 14 anos entre a data de contratação e a data de nascimento',
    '00134': 'Não foi possível salvar os dados',
    '00135': 'Não foi identificado o usuário',
    '00136': 'Não foi definido o algoritmo',
    '00137': 'Não foi definido o hash anterior',
    '00138': 'Não foi possível eliminar o cadastro',
    '00139': 'Erro ao criar a assinatura',
    '00140': 'Erro ao auditar a alteração de senha',
    '00141': 'A senha não cumpre com as políticas da empresa',
    '00142':
      'Acesso inválido. Por favor, solicite novamente a alteração de senha',
    '00143': 'O e-mail não é correto',
    '00144': 'Aconteceu um problema, por favor, entre em contato com suporte',
    '00145':
      'O primeiro login não foi registrado, o e-mail pertence a outro usuário da empresa',
    '00608':
      'A configuração de assinatura se encontra em um site inexistente. Para redefini-la, por favor, entre em contato com o administrador.',
    '02001': 'O tipo de licença é incorreto',
    '02006': 'senha requerida.',
    '02059': 'Digite a senha',
    '02060': 'Não possui permissão para aprovar a licença',
    '02061': 'A empresa não tem uma configuração de licenças',
    '02062': 'Insira o ID requerido',
    '02063': 'O pedido não foi encontrado',
    '02064': 'Aconteceu um erro ao pedir a licença',
    '02065': 'Não foi possível realizar a aprovação da licença',
    '02066': 'Erro ao obter o usuário aprovador.',
    '02067': 'Não se encontra o usuário que está tentando aprovar.',
    '02068': 'Erro ao modificar o status de sua licença',
    '02076': 'senha incorreta',
    '02079': 'Não possui permissão para realizar esta ação',
    '02080': 'Erro ao obter a configuração da empresa',
    '02083': 'O usuário não pode solicitar uma licença',
    '02084': 'Erro na entrada de datas.',
    '02089':
      'Houve um problema ao criar a solicitação, por favor, tente novamente',
    '02090': 'Não foi possível notificar por correio',
    '02091':
      'Erro ao redifinir o aprovador ou ao salvar a aprovação da licença',
    '02092': 'Erro ao salvar os movimentos da licença',
    '02093': 'Erro na aprovação da licença',
    '02094': 'O usuário não existe',
    '02095': 'Erro ao gerar os dias',
    '02096': 'Não possui permissão para criar licenças no usuário selecionado',
    '02097': 'Não possui permissão para executar esta ação',
    '02098': 'Não possui dias suficientes',
    '02099': 'Erro na configuração de subtipos',
    '02100': 'Possui licenças pendentes de aprovação',
    '02101': 'A licença não pode começar num feriado',
    '02102': 'Não é possível obter a configuração do comércio.',
    '02103':
      'Houve um inconveniente ao criar o pedido, por favor, tente novamente',
    '02104':
      "O número de cadastro aprovador é exclusivo do módulo de licenças'",
    '02105': 'O nível de aprovação é exclusivo do módulo de licenças',
    '02106': 'O código de convênio é exclusivo do módulo de licenças',
    '02107': "A antiguidade prévia é exclusiva do módulo de licenças'",
    '02108': 'Não tem dias suficientes para solicitar a licença',
    '02109': 'A licença deve ser solicitada no ano-corrente',
    '02110':
      'Há uma solicitação de licença que se superpõe com aquela que deseja solicitar',
    '02111': 'Não cumpre com a política de fração de licença',
    '02112': 'Não cumpre com a política de fração de licença máxima',
    '02113':
      'Não cumpre com a política de solicitações de licença máxima mensal',
    '02114':
      'Não cumpre com a política de solicitações de licença máxima anual',
    '02115': 'Não cumpre com a política de dias de antecedência',
    '02116': 'Não cumpre com a política do dia inicial',
    '02117': 'O número de dias deve ser um número maior a zero',
    '02118': 'A data de finalização não pode ser inferior à data de início',
    '02119': 'Não há dias úteis na solicitação realizada',
    '02120':
      'Já possui licenças para o período selecionado e ultrapassa a quantidade máxima permitida mensalmente',
    '02121':
      'Já possui licenças para o período selecionado e ultrapassa a quantidade máxima permitida anualmente',
    '02122': 'O módulo de licenças está inativo',
    '02123': 'Erro ao calcular a solicitação',
    '02124': 'O número de usuários ultrapassa o limite para gerar o saldo',
    '02125': 'ID de tipo de licença requerido',
    '02126': 'Tipo de licencias incorrecto',
    '02127': 'Seu perfil não tem permissão para executar esta ação',
    '02128': 'Política não válida',
    '02129': 'Tipo de licença não válido',
    '02130': 'O ID de política e ID de licença são inconsistentes',
    '02131':
      'O ID de usuário deve ser nulo quando utilizar o número de cadastro',
    '02132':
      'O ID de usuário ou número de cadastro é obrigatório para solicitações por terceiros',
    '02138': 'Formato JSON não válido',
    '02139': 'Formato de data incorreto. O formato deve ser DD/MM/AAAA.',
    '02140': 'Já existem ajustes para esta configuração',
    '02141': 'Política não válida',
    '02142': 'Tipo de licença não válido',
    '02143': 'A fração minima deve ser maior a zero',
    '02144': 'Não cumpre com a política de dias múltiplo da fração mínima',
    '02145': 'Subtipo de licença não válido',
    '02146': 'Não cumpre com a política de dia de retorno',
    '02148':
      'Não pode selecionar como dia de início um feriado, selecione o dia útil seguinte',
    '02150': 'Deve consumir, no mínimo, 7 dias de saldo',
    '02151': 'Deve consumir, no mínimo, x dias de saldo',
    '04002':
      'O funcionário não pertence à empresa do usuário que subiu o documento',
    '04003': 'Formato inválido',
    '04004': 'O PDF não pode ultrapassar o total de páginas permitidas',
    '04005': 'Erro ao carregar o arquivo',
    '04006': 'O campo nome é obrigatório',
    '04007': 'O campo template é obrigatório',
    '04008': 'Você não é administrador',
    '04009': 'O campo nome é obrigatório',
    '04010': 'O campo Json é obrigatório',
    '04011': 'Não foi possível obter o usuário',
    '04012': 'Você não tem permissão para executar esta ação',
    '04013': 'O parâmetro Id_type_document é obrigatório',
    '04014': 'O parâmetro Template é obrigatório',
    '04015': 'O parâmetro Files é obrigatório',
    '04016': 'O usuário não possui o action profile requerido',
    '04018': 'A quantidade de arquivos subidos é incorreta',
    '04019': 'O campo de valor é obrigatório',
    '04020': 'O Id_type_documen não pertence à empresa',
    '04021': 'Formato do Json inválido',
    '04022': 'Deve adicionar parâmetros junto ao Json',
    '04023': 'Os parâmetros adentro do Json são incorretos',
    '04024':
      'O funcionário não pertence ao setor do usuário que carregou o documento',
    '04025':
      'O funcionário não pertence à localização do usuário que carregou o documento',
    '04026': 'O documento deve estar em estado inicial',
    '04027': 'O status foi modificado com sucesso',
    '04028': 'Erro ao atualizar a base de dados',
    '04029': 'O status fue modificado com sucesso',
    '04030': 'O parâmetro País não é correto',
    '04031': 'O parâmetro empresa não é correto',
    '04032': 'O ID da empresa deve ser numérico',
    '04033': 'O ID do país deve ser numérico',
    '04034': 'O ID é obrigatório',
    '04035': 'O nome é obrigatório',
    '04036': 'O formato do arquivo é incorreto',
    '04037': 'O ID é incorreto',
    '04038': 'O ID não pertence à carga do usuário',
    '04039': 'Erro na carga do arquivo',
    '04040': 'Nome incorreto.',
    '04041': 'Erro ao atualizar o template',
    '04042': 'Já completou a carga máxima de arquivos',
    '04043': 'Você não pode ver documentos de outras empresas',
    '04044': 'O campo hash é obrigatório',
    '04045': 'Os hash não coincidem',
    '04046': 'Não foi possível criar o diretório corretamente',
    '04047': 'O documento não existe',
    '04049': 'O arquivo ultrapassa o tamanho máximo',
    '04051': 'Não foi possível ler o arquivo PDF',
    '04744':
      'Usuário inabilitado, por favor, entre em contato com o administrador',
    '00146': 'Sua senha expirou, você deve atualizá-la para poder assinar',
    '00147': 'Seu acesso para assinar foi bloqueado por múltiplas tentativas falhas'
  },
  settingsComponent: {
    header: {
      upload: 'Carregar imagem',
      change: 'Editar imagem',
      cropImage: 'Cortar imagem',
      exitEditMode: 'Salvar',
      cancelEditMode: 'Cancelar',
      saveChanges: 'Atualizar foto',
      cropSuccess: 'Imagem de perfil modificada com sucesso',
      title: 'Configuração',
      titleProfilePicture: 'Carregar foto de perfil'
    },
    list: {
      changePassword: {
        title: 'Editar senha',
        dialogTitle: 'Alterar sua senha de acesso',
        labelOldPass: 'Insira senha atual',
        labelPass: 'Insira nova senha',
        labelRePass: 'Repita nova senha',
        samePassValidation: 'As senhas não coincidem',
        success: 'Senha modificada com sucesso'
      },
      changeEmail: {
        title: 'Editar e-mail',
        dialogTitle: 'Modifique seu e-mail pessoal',
        currentEmail: 'Seu correio eletrônico atual associado é',
        labelEmail: 'e-mail novo',
        labelEmail2: 'Correio eletrônico novo',
        labelPassword: 'Senha',
        labelPassword2: 'Senha atual',
        labelEmailAndPassword:
          'Insira um novo correio eletrônico e sua senha atual',
        success: 'E-mail modificado com sucesso'
      },
      switchCompany: {
        title: 'Mudar empresa',
        companyLabel: 'Empresa',
        success: 'Você mudou de empresa',
        stateUser: 'Status',
        companyState1: 'Ativo',
        companyState2: 'Onboarding',
        actionChangeCompany: 'Mudar',
        stateCurrentCompany: 'Atual',
        myCompanies: 'Minhas empresas',
        blockedCompany:
          'Usuário desativado, entre em contato com o administrador.',
        onboardingAlert: {
          cancelBtn: 'Cancelar',
          confirmBtn: 'Mudar',
          header: 'Mudar de empresa',
          text:
            'Na empresa {relatedCompanyName} você está em processo de onboarding. Vai ser redirecionado para a tela de login',
          title: 'Tem certeza de querer mudar de empresa?'
        }
      },
      mfaSettings: {
        dialogTitle: 'Autenticação por e-mail',
        info:
          'Para sua segurança, você pode adicionar um fator de autenticação para verificar o seu acesso através da conta de e-mail associada.',
        yes: 'Sim',
        no: 'Não',
        warnMessageMfaYes:
          'Quando salvar as mudanças, sua sessão será encerrada e você deverá voltar ao loguin para estabelecer a primeira configuração.',
        warnMessageMfaNo:
          'Desativar a Autenticação por e-mail aumenta o risco de acessos não autorizados na sua conta. Caso desative essa opção, recomenda-se reativá-la logo.',
        notEditable:
          'Sua empresa configurou como obrigatório o uso do duplo fator de autenticação, não é possível editar esta seção.',
        passRequiredInfo:
          'Senha requerida para confirmar a mudança na configuração',
        passRequired: 'Por favor, digite sua senha',
        invalidPassword: 'Senha incorreta',
        errorSavingSettings: 'Erro ao salvar a configuração',
        passwordLabel: 'Senha'
      },
      privacyNotice: {
        title: 'Aviso de Privacidade'
      },
      FileUploadComponent: {
        header: {
          title: 'Carga de documentos'
        },
        title_img: 'Selecione o documento a carregar',
        subtitle_img: 'Logo de selecionado, aparecerá aqui',
        stepper: {
          first: 'Escolha o tipo de documento',
          second: 'Preencha os dados necessários',
          third: 'Enviar para RH'
        },
        formComponent: {
          loadSuccess1: 'O documento foi enviado corretamente.',
          loadSuccess: 'O documento foi enviado corretamente.',
          uploadSuccess: 'Carga de documento completada',
          errorLoadSomeDoc: 'Houve um erro na carga do documento.',
          loadAllPages:
            'Por favor, carregue uma imagem em todas as folhas adicionadas.',
          errorOnId: 'Houve um erro ao trazer o id de carga',
          checkSizeOnPdf: 'Por favor, carregue um pdf de até 5 MB',
          selectPdf: 'Por favor, Selecione um pdf',
          selectFile: 'Selecione um arquivo',
          imageSucces: 'A folha foi carregada corretamente',
          selectJpgPng:
            'Por favor, selecione uma imagem jpg ou png de até 5 MB',
          addNewField: 'Adicionar folha',
          replaceField: 'Substituir folha',
          eliminateField: 'Eliminar folha',
          addNewFieldShort: 'Adicionar',
          replaceFieldShort: 'Substituir',
          eliminateFieldShort: 'Eliminar',
          preview: 'Previsualização',
          loadImage: 'Carregar imagem',
          loadFIle: 'Carregar documento',
          invalidFormatFile: 'Arquivo de formato inválido'
        },
        swal: {
          accept: 'Aceitar',
          cancel: 'Cancelar',
          understoodMSG: 'Entendi',
          imageSaved: 'Imagem Salva',
          titleUploadViewer:
            'Você atingiu a quantidade máxima de arquivos permitidos',
          dnimessage: 'Imagem Salva ({uploadLength} de {uploadLength})',
          dniUploading: 'Imagem Salva (1 de {uploadLength})',
          fileUploadingDNI: 'A seguir carregue o ${dniLabelIndex} do documento'
        },
        cameraComponent: {
          buttons: {
            manualCrop: 'Recorte manual',
            autoDetection: 'Detecção automática',
            rotate: 'Rotar Foto'
          },
          permissionDenied: 'Permissão de câmera negada'
        },
        documentSelectLabel: 'Tipo de documento',
        sendDocumentsToS3: 'Enviar',
        total: 'Total',
        emptyState: 'Não há documentos para carregar',
        previewBtn: 'Previsualizar',
        addSheet: '+ Adicionar folha',
        sendRRHH: 'Enviar para RH',
        enableSendRRHH:
          'Para habilitar o botão com a opção Enviar para RH, você deve anexar primeiramente a imagem/pdf solicitado, ou eliminar as folhas adicionais que não necessite preencher.',
        sendFileRRHH:
          'Agora você já pode enviar o documento a RH para sua revisão',
        continueConfig: 'Como deseja continuar?'
      },
      dates: {
        searchByPeriod: 'Pesquisa por período',
        datePicker: 'Escolha uma data',
        dateSince: 'Data desde',
        dateLast: 'Data até',
        cancelButton: 'Cancelar',
        submitButton: 'Ok'
      },
      dateSince: 'Data desde:',
      dateLast: 'até:',
      saveFilters: 'Aplicar',
      CleanFilters: 'Limpar',
      okMsg: 'Aceitar',
      buttonCancel: 'Cancelar',
      save: 'Salvar',
      saveSuccess: 'Salvado corretamente',
      businessChange: 'Alterando empresa',
      authentic: 'Autenticando...'
    },
    changeTo: 'Alterar a',
    changeBussiness: 'Mudar empresa',
    rolTitle: 'Rol',
    changeVisualization: 'Modificar perfil de visualização',
    managerTitle: 'Manager',
    colaboradorTitle: 'Colaborador',
    changeAnotherBusiness: 'Ir para outra empresa',
    myAccount: 'Minha conta',
    changePesonalData: 'Alterar dados pessoais',
    editPassword: 'Editar senha',
    changeAccessKey: 'Alterar senha de login',
    editEmail: 'Editar e-mail',
    changePersonalEmail: 'Alterar e-mail pessoal',
    securityAdds: 'Ajustes de segurança',
    authPreferences: 'Preferências de autenticação',
    privacyPolicy: 'Política de privacidade',
    getOut: 'Sair',
    documents: 'Documentos',
    collab: 'Colaboradores',
    licencesCollab: 'Licenças',
    folders: 'Pasta',
    linkEmailAccount:
      'Tem certeza de querer vincular suas contas com o seguinte [ e-mail ]?',
    confirmAccion: 'Esta ação não pode ser desfeita.'
  },
  documentComponent: {
    details: {
      documentCount: '{length} folha',
      documentCountPlural: '{length} folhas',
      documentTitle: 'Documento',
      confort: 'Conforme',
      notConfort: 'Não conforme',
      notRequiredSign: 'Não requer assinatura'
    },
    unSignDocuments: {
      unsignedDocuments: 'Documentos sem assinar',
      noDocuments: 'Não há documentos para assinar!',
      noFirm: 'Não assinado',
      bloqued: 'Bloqueado',
      consultRRHH: 'Consultado'
    },
    SignedDocuments: {
      myDocuments: 'Meus Documentos',
      dissatisfiedSignature: 'Desconforme',
      noSignedDocuments: 'Você não tem documentos assinados',
      sendDocument: 'Assinar',
      disagreementSignature: 'Assinatura em desconformidade'
    },
    warnings: {
      titleDocumentBloqued: 'Atenção!',
      subtitleDocumentBloqued:
        'Existem documentos anteriores sem assinar. É necessário assinar para poder visualizar este documento.',
      subtitle2DocumentBloqued:
        'É necessário assinar para poder visualizar este documento.'
    },
    filters: {
      combobox: {
        documentTypes: 'Tipo de documento',
        noDocumentTypes: 'Não possui filtros para esta seção',
        comboboxLabel: 'Adicione alguns tags',
        comboboxNoResults: 'Não se encontraram resultados'
      },
      dates: {
        searchByPeriod: 'Pesquisa por período',
        datePicker: 'Escolha uma data',
        dateSince: 'Data desde',
        dateLast: 'Data até',
        cancelButton: 'Cancelar',
        submitButton: 'Ok'
      },
      dateSince: 'Data desde:',
      dateLast: 'até:',
      saveFilters: 'Aplicar filtros',
      CleanFilters: 'Limpar filtros'
    },
    tooltip: {
      main: {
        top: 'Para poder assinar este documento',
        single: 'Você tem que assinar 1 documento prioritário',
        plural: 'Você tem que assinar {count} documentos prioritários',
        bottom: 'Clique no documento para poder revisá-lo e assiná-lo'
      }
    },
    opcions: 'mais opções',
    noDocumentsAble: 'Não tem documentos disponíveis',
    pending: 'Pendentes',
    signed: 'Documentos',
    activeEmployees: 'Só documentos de funcionários ativos',
    toFind: 'Pesquisa por {dni}',
    maxSearch:
      'A pesquisa permite um máximo de 100 {dni} separados por vírgulas',
    timeDocument: 'Tipo de documento / Período',
    sectorLocation: 'Setor / Localização'
  },
  documentVisualizerComponent: {
    loading: {
      loadingMessage: 'Estamos processando sua solicitação, por favor espere...'
    },
    signButtons: {
      signDissatisfied: 'Assinar não conforme',
      rrhhConsult: 'Consultar a RH',
      rrhhConsultReady: 'Ver Consulta',
      signDocument: 'Assinar Documento',
      sendDocument: 'Enviar',
      signWithOptions: 'Mais opções'
    },
    signDialog: {
      signNotConfort: 'Assinar não conforme',
      inputPassword: 'Insira a senha',
      signConfort: 'Assinar Documento',
      cancelButton: 'Cancelar',
      saveButton: 'Assinar Documento'
    },
    signNotConfort: {
      select: 'Outros Motivos',
      reasons: {
        one: 'Apuração de Hs Extras',
        two: 'Apuração outros Conceitos',
        three: 'Outros Motivos',
        four: 'Diferença em apuração de salários',
        five: 'Diferença em apuração de retenções',
        six: 'Diferença em apuração de adicionais'
      }
    },
    consultRRHHModal: {
      consultRRHHTitle: 'Fazer uma consulta a RH',
      consultReadyRRHHTitle: 'Ver consulta',
      submitConsultRRHH: 'Escreva aqui sua consulta a RH',
      cancelButton: 'Cancelar',
      consult: 'Consultar'
    },
    errors: {
      errorDate: 'Houve um erro ao obter a data de assinatura'
    },
    firmSuccess: 'O documento foi assinado corretamente',
    incorrectPassword: 'Senha incorreta',
    consultSuccessRRHH: 'A consulta foi enviada corretamente',
    downloadPDF: 'Descarregar',
    sendEform: 'Enviar Documento',
    printDocument: 'Imprimir',
    forgetPassword: 'Esqueceu sua senha?',
    sending: 'Enviando...'
  },
  licenseComponent: {
    licenseBox: {
      days: 'Dias',
      day: 'Dia',
      // available: 'Disponíveis do tipo licença',
      // registered: 'Registrados do tipo licença',
      // available1: 'Disponível do tipo licença',
      // registered1: 'Registrado do tipo licença',
      available: 'Disponíveis',
      registered: 'Registrados',
      available1: 'Disponível',
      registered1: 'Registrado',
      discountPlural: 'Serão descontados {saldo} dias de {tipo} de seu saldo',
      registerPlural: 'Serão registrados {saldo} dias de {tipo} no seu saldo',
      discountSingular: 'Será descontado {saldo} dia de {tipo} de seu saldo',
      registerSingular: 'Será registrado {saldo} dia de {tipo} no seu saldo',
      discountHalf: 'Será descontado meio dia de {tipo} de seu saldo',
      registerHalf: 'Será registrado meio dia de {tipo} no seu saldo',
      registerAnticipatePayment: 'Solicitar antecipo de pagamento de férias',
      buttonSolicitudeLicense: 'Solicitar',
      buttonSolicitudeLicenseDisabled: 'Não possui dias',
      HistoryLicenses: 'Histórico de solicitações',
      licenseTypeLabel: 'Tipo',
      initError: 'Há um problema de configuração. Informar a RH.',
      datesTitle: 'Selecione data de início e de reincorporação',
      datesRangeTitle: 'Selecione o período de datas',
      datesRangeDescription:
        'Desde o dia que inicia sua licença até o dia em que volta para o escritório',
      dateFromTitle: 'Quando é a data de início?',
      dateToTitle: 'Quando você se reincorpora à empresa?',
      dateFrom: 'Data de início',
      dateTo: 'Data de reincorporação',
      // start: 'Início',
      start: 'Desde',
      // return: 'Reincorporação',
      return: 'Até',
      halfDay: 'Só meio dia',
      approverTitle: 'Quem aprova esta solicitação?',
      approver: 'Aprovador',
      optionalTitle: 'Opções adicionais',
      liqPeriod: 'Período de apuração',
      commentTitle: 'Deseja adicionar algum comentário?',
      commentLabel: 'Observações',
      francos: 'Folgas',
      goOut: 'Sair',
      back: 'Voltar',
      next: 'Seguinte',
      cancel: 'Cancelar solicitação',
      balances: 'Saldos',
      requestLicense: 'Solicitar',
      resume: 'Resumo',
      pendingLicenses:
        'Existem {pendingLicenses} solicitações pendentes de aprovação',
      selectLicenseType:
        'Selecione o tipo de férias ou licenças que deseja solicitar',
      balanceDetails: 'Detalhe de saldo',
      timeRangeDescription: 'Selecione o período de horas',
      discountHours:
        'Serão descontadas {hoursRanges} horas de {tipo} de seu saldo',
      discountSingularHour:
        'Será descontada {hoursRange} hora de {tipo} de seu saldo',
      communicateWithSupport:
        'Erro na configuração da integração de certificados. Por favor, entre em contato, com suporte',
      cciAccountInvalid: 'O número de conta e cci não coincidem',
      sichernPeopleInfo: 'Detalhe do Sichern People',
      inicioLabel: 'Início',
      limiteLabel: 'Limite',
      disponiblesLabel: 'Disponíveis',
      vencenLabel: 'A vencer',
      diasAAcreditarseLabel: 'Dias a serem creditados',
      usadosLabel: 'Usados',
      periodoLabel: 'Período',
      conformacionSaldo: 'Composição do saldo',
      gozadosLabel: 'Gozados',
    }
  },
  LicensesHistoryComponent: {
    tabs: {
      licenses: {
        tabName: 'Solicitações',
        tabName_mine: 'Minhas solicitações',
        myLicenses: 'Minhas férias e licenças',
        title: 'Histórico de férias e licenças',
        subtitleState: 'Status:',
        subtitleStateWaiting: 'Em aprovação',
        subtitleSolicitudeDate: 'Data de solicitação:',
        emptyHistory: 'Não existem licenças ou férias para mostrar',
        emptyHistorySubtitle: 'Sua lista está vazia.',
        emptyHistorySubtitle2: 'Faça uma solicitação e aparecerá aqui',
        noMoreResults: 'Não há mais resultados',
        start: 'Início',
        return: 'Voltar'
      },
      otherRequests: {
        tabName: 'Outras ausências',
        title: 'Outras ausências solicitadas pelo RRHH'
      },
      licensesForApproval: {
        loadLicences: 'Carregar ausências',
        licensesPending: 'Pendentes de aprovação',
        licenseType: 'Tipo:',
        historyLicenses: 'Minhas férias e licenças',
        startDate: ' Data de início:',
        reincorporationDate: 'Data de reincorporação:',
        daysQuantity: 'Quantidade de dias:',
        noLicensesForApprovalTitle: 'Não existem pendentes de aprovação',
        noLicensesForApprovalSubtitle: 'Aqui aparecerão as',
        noLicensesForApprovalSubtitle2:
          'Solicitações que necessitam ser aprovadas',
        day: 'dia',
        days: 'dias',
        from: 'Desde',
        to: 'a',
        return: 'voltar'
      }
    },
    statusPending: 'Pendente',
    statusExpired: 'Saldo vencido',
    downloadDocument: 'Descarregar documento'
  },
  LincensesHistorySummaryComponent: {
    header: {
      title: 'Detalhe de solicitação'
    },
    sumary: {
      quitLicenseOk: 'A solicitação foi cancelada com sucesso'
    },
    labels: {
      licenseType: 'Tipo',
      licenseType2: 'Tipo de licença',
      solicitudeState: 'Status',
      status: 'Status',
      solicitudeDate: 'Data de solicitação',
      request: 'Solicitação',
      approver: 'Aprovador',
      startDate: 'Desde',
      reincorporationDate: 'Até',
      // startDate: 'Início',
      // reincorporationDate: 'Reincorporação',
      return: 'Voltar',
      requestedDays: 'Dias solicitados',
      days: 'Dias',
      accumulatedDays: 'Dias acumulados',
      balance: 'Saldo disponível',
      comment: 'Observações',
      firstApproverState: 'Nas mãos do aprovador nível 1',
      secondApproverState: 'Nas mãos do aprovador nível 2',
      attachmentDocument: 'Documento anexo',
      name: 'Nome',
      licenseDaysByPeriod: 'Dias de férias solicitadas por período',
      action: 'Ação'
    },
    modals: {
      title: 'Tem certeza que deseja cancelar a solicitação?',
      cancelSolicitudeSucces: 'A solicitação foi cancelada com sucesso'
    },
    cancelButton: 'Cancelar Solicitação'
  },
  LincensesApprovalPendingComponent: {
    header: {
      title: 'Detalhe de solicitação'
    },
    labels: {
      nameLastname: 'Solicitante',
      nameLastname2: 'Nome & Sobrenome',
      licenseType: 'Tipo',
      day: 'Dia',
      days: 'Dias',
      stateSolicitude: 'Status da solicitação',
      state: 'Status',
      solicitudeDate: 'Data da solicitação',
      request: 'Solicitação',
      startDate: 'Início',
      reincorporationDate: 'Reincorporação',
      startReturn: 'Início / Voltar',
      requestedDays: 'Dias Solicitados',
      salaryAvailable: 'Saldo disponível',
      salaryAvailablePostApprove: 'Saldo disponível depois de aprovar',
      salaryRegistered: 'Saldo registrado',
      daysInThisYear: 'Dias acumulados no ano atual',
      observations: 'Observações',
      fileNumber: 'Numero de Cadastro',
      employeeInfoTitle: 'Informação do funcionário',
      dni: 'Número de documento',
      email: 'Correio eletrônico',
      historyTitle: 'Histórico de férias & licenças',
      actionDoneBy: 'Ação realizada por',
      action: 'Ação'
    },
    modal: {
      massiveApprove: 'Aprovar seleção',
      massiveReject: 'Rejeitar seleção',
      approveTitle: 'Aprovar solicitação',
      rejectTitle: 'Rejeitar solicitação',
      approverPlaceholder: 'Selecionar seguinte aprovador',
      defaultApproverPlaceholder: 'Definir-me como aprovador por defeito',
      observationsPlaceholder: 'Observações',
      placeholder: 'Insira sua senha',
      label: 'Senha',
      approveLicenseOk: 'A solicitação foi aprovada corretamente.',
      desapproveLicenseOk: 'A solicitação foi rejeitada corretamente',
      cancelButton: 'Cancelar',
      okButton: 'Aceitar',
      cantApproveMassive: 'Esta seleção não permite aprovação massiva.',
      massiveApproveError: 'Algumas solicitações não puderam ser aprovadas.',
      massiveRejectError: 'Algumas solicitações não puderam ser rejeitadas.',
      massiveRejectExpired:
        'Alguma das licenças que está por rejeitar tem saldo vencido',
      singleRejectExpired:
        '{days} dias solicitados ultrapassam a data de validade, caso os rejeite, o saldo vencerá'
    },
    cancelButton: 'Rejeitar',
    approveButton: 'Aprovar'
  },
  LicensesSolicitudeComponent: {
    header: {
      title: 'Solicitar'
    },
    modals: {
      solicitudeOk: 'A solicitação foi criada com sucesso',
      cancelRequest: 'Tem certeza que deseja cancelar esta solicitação?',
      yes: 'Sim',
      no: 'Não',
      continue: 'Continuar'
    },
    fileUploadMessage: 'Anexe a documentação correspondiente'
  },
  LicensesManager: {
    goBack: 'Voltar para a gestão',
    orderBy: 'Ordenar por',
    redirect: {
      title: 'Infelizmente esta página não está disponível neste dispositivo.',
      subtitle: 'Para acessar você deve entrar do seu computador',
      backToHome: 'Voltar ao home'
    },
    rotateScreen: {
      title: 'Rotar dispositivo',
      subtitle:
        'Para poder visualizar corretamente esta tela é necessário rotar seu dispositivo',
      hint: 'Lembre ativar a rotação de tela na configuração de seu celular'
    },
    landing: {
      title: 'Gestão de licenças',
      title_request: 'Solicitar',
      subtitle_request: 'Solicite suas licenças e férias',
      info_request1: '{availableDays} Dias',
      info_request2: 'Disponíveis de {licenseType}',
      info_request_registered: 'Registrados de {licenseType}',
      title_pending: 'Pendentes de aprovação',
      subtitle_pending:
        'Aprove ou rejeite as solicitações pendentes de seus funcionários',
      info_pending1: '{pendingLicenses} licenças',
      info_pending2: 'Pendentes de aprovação',
      title_licenses_search: 'Consulta de solicitações',
      subtitle_licenses_search:
        'Consulte e exporte o detalhe de uma ou várias solicitações',
      title_balances: 'Extrato de saldo',
      subtitle_balances:
        'Consulte e exporte o saldo detalhado dos funcionários',
      title_nonworkingdays: 'Feriados',
      subtitle_nonworkingdays: 'Consulte os feriados por país e por empresa'
    },
    search: {
      title: 'Consulta de solicitações',
      empty: 'Os resultados de sua pesquisa aparecerão aqui',
      userHint: 'Você pode pesquisar por nome, sobrenome ou CPF',
      user: 'Usuário',
      status: 'Status',
      type: 'Tipo',
      userStatus: 'Status usuário',
      fromPeriod: 'Período desde',
      toPeriod: 'Período até',
      liqPeriod: 'Período de apuração',
      search: 'Pesquisar',
      export: 'Exportar',
      exportLoading: 'Exportando...',
      fileNumber: 'Número de cadastro',
      requestDate: 'Data de solicitação',
      sector: 'Setor',
      location: 'Localização',
      balanceDetail: 'Conformação de saldo',
      nameLastname: 'Nome e Sobrenome',
      lastnameName: 'Sobrenome e Nome',
      searchName: 'Sobrenome e Nome / {dni}',
      name: 'Nome',
      surname: 'Sobrenome',
      start: 'Início',
      return: 'Reincorporação',
      days: 'Dias',
      statusList: {
        pendingSupervisor: 'Em aprovação Supervisor',
        pendingHr: 'Em aprovação RH',
        approved: 'Aprovada',
        cancelled: 'Cancelada',
        rejected: 'Rejeitada',
        outdated: 'Vencida',
        assignment: 'Designação'
      },
      userStatusActive: 'Ativo',
      userStatusUnactive: 'Inativo',
      all: 'Todos',
      fileUploaded: 'Documento carregado',
      fileNotUploaded: 'Documento não carregado',
      viewUploadedFile: 'Ver documento'
    },
    balances: {
      title: 'Extrato de saldo',
      period: 'Período',
      woBalance: 'Sem saldo'
    },
    holidays: {
      title: 'Feriados',
      subtitle: 'Dias festivos do ano {year}',
      day: 'Dia',
      name: 'Nome',
      type: 'Tipo',
      politicHoliday: 'Feriado por política',
      companyHoliday: 'Feriado por empresa',
      countryHoliday: 'Feriado por país',
      deleteHolidayQuestion:
        'Tem certeza que quer eliminar o feriado {holiday}?',
      delete: 'Eliminar',
      deleteSuccess: 'O feriado foi eliminado com sucesso'
    },
    managerLicense: {
      title_calendar: 'Calendário',
      subtitle_calendar: 'Veja o estado das ausências de seus colaboradores'
    }
  },
  UploadLanding: {
    pageTitle: 'Enviar documento',
    uploadFile: {
      title: 'Carga de arquivos',
      description:
        'Enviar documentação a recursos humanos. Tire uma foto ou selecione um arquivo pdf.',
      button: 'Ir para carga de arquivos'
    },
    pickup: {
      title: 'Preencher formulários',
      titleSing: 'Preencher formulário',
      description:
        'O setor de recursos humanos disponibilizá formulários para você preencher quando necessário.',
      button: 'Ir para preencher formulários'
    }
  },
  FileUploadComponent: {
    header: {
      title: 'Carga de documentos'
    },
    title_img: 'Selecione o documento a carregar',
    subtitle_img: 'Depois de selecionado aparecerá aqui',
    stepper: {
      first: 'Escolha o tipo de documento',
      second: 'Preencha os dados necessários',
      third: 'Enviar para RH'
    },
    formComponent: {
      loadSuccess1: 'O documento foi enviado corretamente.',
      loadSuccess: 'O documento foi enviado corretamente.',
      uploadSuccess: 'Carga de documento completada',
      errorLoadSomeDoc: 'Houve um erro na carga do documento.',
      loadAllPages:
        'Por favor carregue uma imagem em todas as folhas adicionadas.',
      errorOnId: 'Houve um erro ao trazer o id de carga',
      checkSizeOnPdf: 'Por favor, carregue um pdf de até 5 MB',
      selectPdf: 'Por favor, selecione um pdf',
      selectFile: 'Selecione um arquivo',
      selectFilePdf: 'Selecionar arquivo PDF',
      selectFileImage: 'Selecionar imagem',
      imageSucces: 'A folha foi carregada corretamente',
      selectJpgPng: 'Por favor, selecione uma imagem jpg ou png de até 5 MB',
      addNewField: 'Adicionar folha',
      replaceField: 'Substituir folha',
      eliminateField: 'Eliminar folha',
      addNewFieldShort: 'Adicionar',
      replaceFieldShort: 'Substituir',
      eliminateFieldShort: 'Eliminar',
      preview: 'Previsualização',
      takeAPhoto: 'Tirar foto',
      selectDocument: 'Selecionar documento',
      searchFile: 'Procurar arquivo',
      allowedFiles: 'Arquivos permitidos',
      maxFileSize: 'Tamanho máximo'
    },
    swal: {
      accept: 'Aceitar',
      cancel: 'Cancelar'
    },
    cameraComponent: {
      buttons: {
        manualCrop: 'Recorte manual',
        autoDetection: 'Detecção automática',
        rotate: 'Rotar Foto'
      },
      permissionDenied: 'Permissão de câmera negada'
    },
    documentSelectLabel: 'Tipo de documento',
    sendDocumentsToS3: 'Enviar',
    total: 'Total',
    emptyState: 'Não há documentos para carregar'
  },
  Pickup: {
    text_fail_password: 'senha incorreta',
    cancel: 'Cancelar',
    text_send: 'Enviar',
    title_eforms_sign: 'Insira Senha',
    accept: 'Aceitar'
  },
  first_login_terms_conditions: 'termos e condições',
  passwordPolicies: {
    rangeChar:
      'A senha deve ter pelo  menos {min} caracteres e {max} no máximo.',
    minMayus: ' A senha deve ter pelo menos {min} carácter em maiúscula.',
    minLongLetter: ' A senha deve ter pelo menos {min} letra.',
    // mayusRange: "A senha deve ter entre {minMayus} e {maxMayus} maiúsculas.",
    // numberRange: "A senha deve ter entre {minNumber} e {maxNumber} números.",
    // specialCharRange: "A senha deve ter entre {minSpecial} e {maxSpecial} caracteres especiais.",
    // specialCharAllowed: "Caracteres especiais permitidos: {specialChar}.",
    anotherRules:
      'A senha não pode conter informação pessoal do usuário (Usuário, Nome, Sobrenome)'
  },
  greeting: {
    morning: 'Bom dia',
    afternoon: 'Boa tarde',
    evening: 'Boa noite'
  },
  eforms: {
    titles: {
      warning: 'Atenção!'
    },
    errors: {
      e12029:
        'Alguma das imagens em anexo não é válida. Por favor, verifique e tente novamente',
      e12030:
        'Alguma das imagens não foi armazenada. Por favor, tente mais tarde'
    },
    digitalForms: 'Formulários digitais'
  },
  mfa: {
    code_authentication: {
      title: 'Código de verificação',
      sub_title_wrong_code:
        'O código de verificação não é válido. Por favor, tente novamente',
      sub_title_valid_code:
        'Digite o código de verificação de 6 números que enviamos a seu e-mail',
      sub_title_expired_code: 'Código expirado',
      sub_title_resend_code: 'Reenviar Código',
      sub_title_time_expired_code: 'O código expira em',
      go_back_btn: 'Voltar',
      send_btn: 'Enviar',
      sending_btn: 'Enviando',
      maxFailsExceededDescription:
        'Você fez muitas tentativas fracassadas, faça login novamente',
      go_to_login_btn: 'Ir para o login',
      SYSTEM_MFA_AUTH_MAX_RESEND_EXCEEDED:
        'Você fez muitas petições ao servidor.',
      COULD_NOT_SEND_MAIL: 'O e-mail não foi enviado'
    },
    email_verification: {
      title: 'Insira um e-mail',
      description:
        'Por sua segurança, necessitamos verificar sua conta de e-mail associada, por favor insira um e-mail válido. Enviaremos um código que deverá inserir no seguinte passo.',
      input_label: 'e-mail',
      go_back: 'Voltar',
      send: 'Enviar'
    },
    userBlock: {
      title: 'Código de verificação',
      description:
        'Você fez muitos pedidos de verificação. Por segurança, sua conta foi inabilitada por 1 hora',
      go_back_btn: 'Voltar'
    }
  },
  notifications: {
    new_update: 'Há uma nova atualização',
    understood: 'Entendi'
  },
  selfService: {
    goBack: 'Voltar',
    title: 'Atualização de dados',
    sections: {
      contact: 'Dados de contato',
      bank: 'Dados bancários',
      identifies: 'Como me identifico',
      address: 'Modificar endereço'
    },
    actions: {
      save: 'Atualizar dados',
      sign: 'Assinar'
    },
    fields: {
      name: 'Como você prefere ser chamado?',
      genre: 'Gênero',
      photo: {
        title: 'Quer atualizar sua foto na plataforma?',
        description:
          'Você pode enviar uma foto para atualizar seu perfil pessoal. Tente carregar uma foto bem iluminada',
        isOk: 'Sim, quero atualizar minha foto',
        notOk: 'Não, em outra hora'
      },
      country: 'País de residência',
      state: 'Província ou estado',
      city: 'Cidade',
      street: 'Rua',
      number: 'Número',
      flat: 'Andar',
      department: 'referência ao # de apartamento',
      neighborhood: 'Bairro',
      block: 'Complemento',
      addressType: 'Tipo de endereço',
      nameBank: 'Banco',
      cbu: 'CBU',
      typeAccount: 'Tipo de conta',
      phone: 'Telefone fixo',
      cellPhone: 'Telefone celular',
      contactPerson: 'Pessoa de contato',
      contactType: 'Tipo de contato',
      emergencyPhone: 'Telefone de emergência',
      cuentaBancaria: 'Número de conta',
      cuentaCci: 'Número de conta interbancária'
    },
    changeAdressWarning:
      'A informação fornecida tem força de Declaração juramentada. Ao atualizar os dados, você assinará o documento, o qual será visível na pasta de documentos',
    fieldsError: {
      phone: {
        regex: 'Só se admite números',
        min: 'Não cumpre com o mínimo de caracteres'
      },
      phoneEmergence: {
        regex: 'Só se admite números',
        min: 'Não cumpre com o mínimo de caracteres'
      },
      celular: {
        regex: 'Só se admite números',
        min: 'Não cumpre com o mínimo de caracteres'
      },
      people: {
        regex: 'Só se admite letras',
        required: 'A pessoa de contato é obrigatória',
        min: 'Não cumpre com o mínimo de caracteres'
      },
      contactType: {
        regex: 'Só se admiten letras',
        required: 'O tipo de contato é obrigatório',
        min: 'Não cumpre com o mínimo de caracteres'
      },
      name: {
        required: 'O Nome é obrigatório',
        regex: 'Só se admitem letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres'
      },
      genre: {
        regex: 'Só se admitem letras',
        required: 'O gênero é obrigatório'
      },
      file: {
        format: 'O arquivo deve ser um formato de imagem válido',
        size: 'O arquivo não pode ultrapassar os 2 MB',
        required: 'Não se adicionou uma imagem'
      },
      country: {
        required: 'O país é obrigatório',
        regex: 'Só se admitem letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres'
      },
      state: {
        required: 'A província ou estado é obrigatório',
        regex: 'Só se admitem letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres'
      },
      city: {
        required: 'A cidade é obrigatória',
        regex: 'Só se admitem letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres'
      },
      street: {
        regex: 'Só se admitem números e letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres'
      },
      streetVp: {
        required: 'A rua é obrigatória',
        regex: 'Só se admitem números e letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'A longitude da rua é muito extensa. Máximo 250 caracteres'
      },
      number: {
        regex: 'Só se admitem números',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres'
      },
      numberVp: {
        required: 'O número de rua é obrigatório',
        regex: 'Só se admitem números',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'A longitude do número de rua é muito extensa, Máximo 8 caracteres'
      },
      flat: {
        regex: 'Só se admitem números e letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres'
      },
      flatVp: {
        regex: 'Só se admitem números e letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'A longitude do andar é muito extensa. Máximo 8 caracteres'
      },
      department: {
        regex: 'Só se admitem números e letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres'
      },
      departmentVp: {
        regex: 'Só se admitem números e letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'A longitude do departamento é muito extensa. Máximo 8 caracteres'
      },
      neighborhood: {
        regex: 'Só se admitem números e letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres'
      },
      neighborhoodVp: {
        regex: 'Só se admitem números e letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'A longitude do bairro é muuito extensa. Máximo 30 caracteres'
      },
      block: {
        regex: 'Só se admitem números e letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres'
      },
      type_domicile: {
        required: 'O tipo de endereço é obrigatório',
        regex: 'Só se admitem letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres'
      },
      nameBank: {
        required: 'O nome do banco é obrigatório',
        regex: 'Só se admitem números e letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres'
      },
      cbu: {
        regex: 'Só se admitem números e letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres',
        is_cbu: 'O número de conta não tem um formato válido',
        cbu_length: 'O número de conta deve ter 22 caracteres'
      },
      typeAccount: {
        required: 'O tipo de conta é obrigatório',
        regex: 'Só se admitem números e letras',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres'
      },
      cuentaBancariaSueldo: {
        required: 'O número de conta é obrigatório',
        regex: 'Só se admitem números',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres'
      },
      cuentaSueldoCci: {
        required: 'O número de CCI é obrigatório',
        regex: 'Só se admitem números',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres',
        is_cci: 'O CCI não tem um formato válido',
        cci_length: 'O CCI deve ter 20 caracteres'
      },
      cuentaBancariaCts: {
        required: 'O número de conta é obrigatório',
        regex: 'Só se admitem números',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres'
      },
      cuentaCtsCci: {
        required: 'O número de CCI é obrigatório',
        regex: 'Só se admitem números',
        min: 'Não cumpre com o mínimo de caracteres',
        max: 'Ultrapassou o máximo de caracteres',
        is_cci: 'O CCI não tem um formato válido',
        cci_length: 'O CCI deve ter 20 caracteres'
      }
    },
    response: {
      success: 'A informação foi enviada corretamente e espera aprovação',
      successCancel: 'A solicitação de aprovação foi cancelada com sucesso',
      errors: {
        SYSTEM_API_MIN_LENGTH_VALUE_NOT_REACHED:
          'Não foi preenchido o mínimo de caracteres em um ou mais campos',
        SYSTEM_API_MAX_LENGTH_VALUE_EXCEEDED:
          'Ultrapassou o valor de longitude máxima em um ou mais campos',
        SYSTEM_API_WRONG_MIME_TYPE: 'Mime Type de imagem incorreto',
        SYSTEM_API_PARAMETER_ENUM_VALUES:
          'O valor do parâmetro não é o esperado na matriz de numeração',
        SYSTEM_API_PARAMETER_REQUIRED: 'Campo requerido não enviado',
        EXPECTED_PARAMETER_VALUE: 'Não foi inserido dado algum',
        SYSTEM_API_WRONG_DATA_TYPE:
          'Um ou vários dados inseridos não são do tipo correto',
        SYSTEM_API_PARAMETER_IS_EMPTY:
          'Um ou vários dados inseridos são obrigatórios',
        SERVICE_UNAVAILABLE_EXCEPTION:
          'Aconteceu um erro. Por favor, tente novamente mais tarde',
        UPLOAD_FILE_EXCEPTION: 'A imagem não foi enviada',
        notFound:
          'A solicitação que você tenta cancelar não existe ou já foi aprovada',
        SYSTEM_API_PARAMETER_NOT_EXPECTED:
          'Um ou vários parâmetros são inválidos',
        ADDRESS_DOCUMENT_USER_PASSPHRASE_NOT_VALID: 'A senha não é válida',
        ADDRESS_DOCUMENT_SIGN_EXCEPTION: 'Não foi possível gerar a assinatura',
        ADDRESS_DOCUMENT_DOCUMENT_TYPE_NOT_DEFINED:
          'O tipo de documento não está definido',
        ADDRESS_DOCUMENT_STORING_EXCEPTION: 'O documento não foi salvo',
        ADDRESS_DOCUMENT_TEMPLATE_EXCEPTION:
          'Não é possível gerar o documento para alterar o endereço',
        ADDRESS_DOCUMENT_VALIDATION_FAILED: 'Falha na validação',
        ADDRESS_DOCUMENT_REQUEST_UPDATE_EXCEPTION:
          'Não é possível atualizar a solicitação de alteração de endereço'
      }
    },
    modal: {
      cancelDialog: {
        title: 'Atualização de dados',
        body:
          'Tem certeza que quer cancelar a solicitação de alterar informação?',
        cancelButton: 'Não, cancelar',
        cancelButtonOK: 'Sim, cancelar'
      }
    },
    infoEmployee: {
      tab: {
        personalData: 'Pessoais',
        contactData: 'Contato',
        bankData: 'Bancários',
        salary: 'Evolução salarial',
        identificationData: 'Como me identifico',
        addressData: 'Endereço',
        emptyTab:
          'O Colaborador não atualizou sua informação. Quando atualizar sua informação, estará disponível nesta tela. ',
        fileNumber: 'Número de Cadastro'
      },
      addressInfo: {
        address: 'Endereço',
        country: 'País de residência',
        state: 'Província / Estado',
        city: 'Cidade',
        street: 'Rua',
        addressNumber: 'Número',
        floor: 'Andar',
        department: 'Apartamento',
        neighborHood: 'Bairro',
        blockStreet: 'Quarteirão',
        addressType: 'Tipo de endereço'
      },
      identifyInfo: {
        identifies: 'Como me identifico',
        nickName: 'Nickname',
        myGenre: 'Gênero selecionado',
        identifyGenre: {
          man: 'Homem',
          woman: 'Mulher',
          noBinary: 'ão binário',
          other: 'Outro'
        }
      },
      personalInfo: {
        personal: 'Pessoais',
        usuario: 'Usuário',
        nombre: 'Nome',
        apellido: 'Sobrenome',
        dni: 'Documento de identidade',
        cuil: 'CPF',
        cuils: 'CPF',
        fecha_nacimiento: 'Data de nascimento',
        fecha_contratacion: 'Data de entrada',
        fileNumber: 'Número de cadastro',
        mail: 'E-mail',
        orgData: 'Dados de organização',
        sectionCompany: 'Setor',
        locationCompany: 'Localização',
        cargo: 'Cargo',
        reporta_a: 'Reporta a'
      },
      contactInfo: {
        contact: 'Contato',
        personal: 'Dados pessoais',
        personalPhone: 'Telefone fixo',
        cellphone: 'Telefone celular',
        emergencyData: 'Dados emergência',
        telephone_emergency: 'Telefone de emergência',
        contactPerson: 'Pessoa de contato (nome)',
        contactType: 'Tipo de contato'
      },
      bankInfo: {
        bank: 'Bancários',
        nameBank: 'Nome do banco',
        cbu: 'CBU ou alias',
        bankAccountType: 'Tipo de conta'
      },
      salaryInfo: {
        salary: 'Evolução do salário'
      }
    },
    emailForm: {
      '00069': 'Digite a senha necessária para atualizar o email',
      '00070': 'O email a ser atualizado não foi definido',
      '00074': 'O email não está correto',
      '00071': 'Senha incorreta',
      '00072': 'O usuário não foi identificado',
      '00073': 'Você não tem permissão para modificar o usuário',
      '00003': 'Token de sesión inválido'
    }
  },
  myTeam: {
    title: 'Minha equipe direta',
    shortName: 'Minha equipe',
    notFound: {
      title: 'Isto é um deserto...',
      description: 'Você não tem uma equipe associada neste momento',
      caption:
        'Você poderá ver sua equipe quando o administrador atualize a informação no sistema'
    },
    tooltipInfo:
      'O seguinte gráfico representa sua equipe direta, ou seja, aqueles colaboradores que reportam diretamente a você. Também permite ver para quem você reporta diretamente.',
    noFiles: 'Não possui documentos pendentes de assinatura',
    signedDocuments:
      'Se quiser consultar um documento assinado você pode ir para a sessão de assinados',
    errorSend: 'Erro ao enviar os termos:',
    noFilesFound: 'Não possui documentos pendentes',
    added: 'Adicionados',
    added2: '{lngt} Adicionados',
    addTxt: 'Pode adicionar até 100',
    addTxt2: 'separados por vírgulas',
    addTxt3: 'Pode adicionar até 100 {dni} separados por vírgulas',
    selectAll: 'Selecionar todos',
    txtPapa: 'ACA PAPA',
    chartData: 'Presentes,Ausentes',
    desc: 'Descendente',
    asc: 'Ascendente'
  },
  dashboard: {
    hello: 'Olá',
    absences: 'Ausências',
    myTeam: 'Minha equipe direta',
    members: 'MEMBROS',
    seeMembers: 'Ver minha equipe',
    pendingFirm: 'Documentos a assinar',
    mine: 'MEUS',
    teams: 'EQUIPE',
    searchDocuments: 'Pesquisar documentos',
    events: 'Eventos',
    birthday: 'Aniversários',
    years: 'Anos',
    noEvents: 'Sem eventos',
    uploadLicence: 'Carregar ausência a colaborador',
    licenseTypeLabel: 'Tipo de licença',
    colaboratorLabel: 'Pesquisar colaborador',
    pendingTasks: {
      title: 'Tarefas pendentes',
      LICENSES: 'Licenças',
      notFound: 'Não possui tarefas pendentes'
    },
    notFound: {
      title: 'Isto é um deserto...',
      description: 'Não tem aniversários para comemorar'
    },
    goBack: 'Voltar',
    salaryAdvance: {
      title: 'Antecipo de salário a colaborador',
      advanceReason: 'Motivo do antecipo',
      requestMont: 'Valor a solicitar',
      requested: 'Antecipo solicitado',
      expectedDate: 'Data prevista',
      btnTitle: 'Solicitar antecipo',
      viewRequests: 'Ver solicitações',
      seeDetail: 'Ver detalhes'
    },
    balanceReport: 'Relatório de saldo de minha equipe',
    sendReminder: 'Enviar lembrete',
    seeAbsences: 'Ver ausências',
    LoadAbsences: 'Carregar ausências'
  },
  salaryAdvanceForm: {
    header: 'Solicitar adiantamento de salário',
    goBack: 'Voltar',
    title: 'Dados do adiantamento',
    reason: 'Qual é o motivo do adiantamento?',
    reasonDescription:
      'Indique o motivo pelo qual você precisa do adiantamento',
    amount: 'Qual é o valor a solicitar?',
    amountDescription: 'Insira o valor que deseja receber',
    dateRange: 'Quando você quer receber o adiantamento?',
    dateRangeDescription:
      'Selecione a data em que espera receber a acreditação.',
    dateRangePlannedDateRemember: 'Lembre-se! A data efetiva de crédito do adiantamento dependerá dos processos de fechamento da empresa.',
    btnCancel: 'Cancelar',
    btnLoad: 'Solicitar adiantamento',
    reasonLabel: 'Motivo do adiantamento',
    amountLabel: 'Valor do adiantamento',
    requestUser: 'Quem receberá o adiantamento?',
    requestUserDescription:
      'Selecione o colaborador ao qual você vai atribuir o adiantamento',
    requestUserLabel: 'Buscar colaborador',
    modal: {
      requestTitle: 'Solicitar adiantamento',
      requestAdvice:
        'Você tem certeza de que quer solicitar um adiantamento de salário?',
      request: 'Solicitar Adiantamento',
      cancelAdvice:
        'Tem certeza de que quer sair da solicitação de adiantamento?',
      warning: 'As alterações realizadas não serão salvas',
      confirmCancel: 'Sim, sair',
      requestAdviceMessage:
        'Você vai solicitar um adiantamento de salário, {collaboratorName} com o motivo de {reason}, pelo valor total de ${amount} com uma data prevista de pagamento {dateSelected}.'
    }
  },
  loadLicence: {
    head: 'Carregar ausência',
    goBack: 'Voltar',
    title: 'Dados da ausência',
    licenceColaborator: 'Quem estará ausente?',
    colaboratorDescription:
      'Selecione o colaborador no qual vai carregar a ausência',
    typeDescription: 'Escolha o tipo de ausência que corresponde',
    licenceType: 'Qual o tipo de licença que vai selecionar?',
    dateRange: 'Qual será o período de duração da ausência?',
    dateRangeDescription: 'Indique a data de início e finalização da ausência.',
    btnCancel: 'Cancelar',
    btnLoad: 'Carregar licença'
  },
  documentsManagement: {
    title: 'Gestão de documentos',
    cards: {
      upload: {
        title: 'Enviar documento',
        subtitle:
          'Envio de documentação você pode enviar Fotos, arquivos e formulários'
      },
      certificates: {
        title: 'Solicitar certificados',
        subtitle:
          'Solicite ao departamentos de rh seus certificados de forma simples'
      },
      history: {
        title: 'Histórico',
        subtitle: 'Consulta de solicitações',
        description: 'Consulte o estado de seus documentos e certificados'
      }
    }
  },
  virtualAssistantAI: {
    title: 'Atendente AI',
    text: 'Texto',
    audio: 'Áudio',
    termsAndConditionsPrev:
      'Antes de começar, é necessário ler e aceitar os termos e condições.',
    termsAndConditionsAccept: 'Aceito os termos e condições',
    start: 'Começar',
    selectQuestion:
      'Qual informação do documento quer consultar? Escolha uma opção.',
    audioNotSupported: 'Seu navegador não suporta a reprodução de áudio.',
    consultAgain: 'Mais alguma consulta?',
    moreInformation:
      ' Podemos te fornecer maiores informações sobre estes temas, escolha uma opção.',
    seeTermsAndCondition: 'Ver termos e condições'
  },
  certificates: {
    goBack: 'Voltar',
    title: 'Solicitar certificados',
    sections: {
      all: 'Todos',
      moreRequested: 'Os mais solicitados',
      requested: 'Solicitações'
    },
    cards: {
      all: {
        title: 'Pesquisar tipo de certificado',
        subtitle: 'Pesquise e selecione certificados para solicitar'
      }
    },
    modal: {
      title: 'Solicitar certificado',
      search: 'Selecione um certificado da lista para poder descarregá-lo',
      cancel: 'Cancelar',
      download: 'Descarregar',
      downloadItem: 'Tem certeza que quer descarregar {item}?',
      select: 'Selecione uma opção',
      noResultsText: 'Não há resultados de pesquisa',
      notAvailableText: 'Não há certificados disponíveis para solicitar'
    },
    error: {
      download:
        'O certificado que está querendo descarregar não está disponível ou não existe.'
    },
    table: {
      title: 'Certificados solicitados',
      download: 'Descarregar'
    }
  },
  modalTimer: {
    title: 'Seu tempo está por expirar',
    title2: 'Sessão expirada',
    body: {
      textCount: 'Sua sessão encerrará em:',
      textSeg: 'seg.',
      textExpire: 'Sua sessão expirou.',
      textExpire2: 'Faça login novamente.'
    },
    buttons: {
      close: 'Fechar',
      closeSession: 'Fechar sessão',
      continue: 'Continuar'
    }
  },
  linkUser: {
    linkAccountModal: {
      modalTitle: 'Vincular contas',
      title:
        'Detectamos {linkUserCount} conta(s) no seu usuário, Você quer iniciar a vinculação de suas contas?',
      description:
        'É possível que você tenha trabalhado com outros empregadores e que tenha acesso a múltiplas contas. Vinculando-as, centralizará o acesso a toda sua documentação em uma única conta.',
      cancelButton: 'Em outra hora',
      successOkBtn: 'Ir para vincular contas'
    },
    title: 'Vinculação de contas',
    titleSection: 'Suas contas',
    description:
      'Para validar que esta conta é sua, é necessário fazer login com usuário e senha.',
    linkingPageDescription:
      'Para vincular suas contas é necessário inserir usuário e senha com o qual vai poder acessar todas suas contas.',
    forgetPassword: 'Esqueci minha senha',
    notLinked: 'Não quero vincular esta conta',
    cancelBtn: 'Cancelar',
    nextButton: 'Seguinte',
    linkAccountBtn: 'Vincular',
    cancelLinkUserModal: {
      modalTitle: 'Sair de vinculação de contas',
      title: 'Tem certeza que quer sair da vinculação de contas?',
      description: 'As alterações realizadas não foram salvas.',
      cancelButton: 'Cancelar',
      successOkBtn: 'Sim, sair'
    },
    verificationStep: {
      descriptionCodeSent:
        'Por segurança necessitamos verificar sua conta de e-mail associada, por favor insira um e-mail válido. Enviaremos um código que deverá inserir no seguinte passo.',
      descriptionCodeNotSent:
        'Por segurança necessitamos verificar sua conta de e-mail associada, por favor insira um e-mail válido. Enviaremos um código que deverá inserir no seguinte passo.',
      invalidEmail: 'O correio eletrônico não é válido'
    },
    successModal: {
      modalTitle: 'Vinculação finalizada',
      title: 'A vinculação de contas foi realizada com sucesso ',
      description:
        'Agora você pode acessar todas suas contas com um único usuário e senha.',
      advice: 'Lembre utilizar a nova senha.',
      toHome: 'Ir para o home'
    },
    noLinkAccountModal: {
      modalTitle: 'Não quero vincular contas',
      title: 'Tem certeza que não quer vincular esta conta?',
      description:
        'Se confirmar, você não poderá acessar os documentos dessa conta. Selecione um motivo pelo qual não deseja fazer a vinculação.',
      firstOption: 'Não quero fazer a vinculação',
      secondOption: 'Não sou proprietário / Desconheço esta conta',
      cancelBtn: 'Cancelar',
      successOkBtn: 'Confirmar'
    }
  },
  workflow: {
    title: 'Consulta de solicitações',
    table: {
      title: 'Histórico de documentos e solicitações',
      approveBy: 'Aprovado por:',
      rejectedBy: 'Rejeitado por:',
      atDay: 'no dia',
      comment: 'Comentário:',
      seeDocument: 'Ver documento',
      columns: {
        date: 'Data',
        applicant: 'Solicitado por',
        documentType: 'Tipo de Documento',
        status: 'Status',
        actions: 'Ações',
        chip: 'workflow'
      }
    },
    status: {
      coursed: 'EM ANDAMENTO',
      approved: 'APROVADO',
      rejected: 'REJEITADO',
      cancelled: 'CANCELADO',
      new: 'NOVO'
    },
    modal: {
      close: 'Fechar'
    },
    goBack: 'Voltar',
    hideFilters: 'Ocultar filtros',
    showFilters: 'Mostrar filtros',
    digitalForm: 'Dados de formulários digitais',
    sheetResult: 'Resultados a folha de cálculo',
    digitalFormData: 'Descarregar dados de formulários digitais',
    allFormResult:
      'A seguir aparecerão todos os formulários encontrados dentro do resultado da pesquisa.',
    csvFormat: 'Ao descarregar os dados aparecerão em formato csv',
    templateName: 'Nome Template',
    downloadData: 'Descarregar dados',
    creationDate: 'Data de criação',
    period: 'Período',
    urlNoValid: 'não é válida a url',
    uploadedError: 'Erro na carga de arquivos',
    btnConsult: 'Botão Consulta do Contracheque'
  },
  label: {
    userHint: 'Você pode pesquisar por nome, sobrenome ou CPF'
  },
  datatable: {
    noDataText: 'Não há dados disponíveis'
  },
  at: 'em',
  sichernConnect: {
    modal: {
      title: 'Vincule sua conta com o Sichern Connect',
      body: {
        text: 'Proteja seu acesso e simplifique seu login vinculando sua conta ao Sichern Connect, nossa plataforma centralizada de autenticação.',
        accept: 'Vincular',
        disagree: 'Em outro momento'
      },
      bodyNoEmail: {
        description: 'Você só precisa fazer isso uma vez e obterá:',
        list: {
          item1: 'Maior segurança nas suas informações.',
          item2: 'Acesso simples e rápido'
        },
        noEmailText: 'Não conseguimos detectar seu e-mail. Insira-o para vincular sua conta.',
        placeholder: 'Insira seu e-mail *',
        passwordPlaceholder: 'Insira sua senha',
        errorRequired: 'Este campo é obrigatório',
        errorInvalid: 'O e-mail não é válido'
      },
      bodyConfirm: {
        description: 'A vinculação será feita com este e-mail:'
      },
      notification: {
        successTitle: 'E-mail enviado com sucesso.',
        successMessage: 'Verifique sua caixa de entrada para continuar o processo de vinculação com o Sichern Connect.',
        errorTitle: 'Erro ao vincular a conta.',
        errorMessage: 'Ocorreu um erro ao tentar vincular sua conta. Por favor, tente novamente.',
        infoPasswordTitle: 'Sua senha de assinatura digital expirou.',
        infoPasswordMessage: 'Para continuar assinando sua documentação, você precisa criar uma nova senha.'
      }
    },
    success: {
      title: 'Vinculação bem-sucedida!',
      button: 'Entendido'
    },
    error: {
      title: 'Erro ao vincular a conta',
      description: 'Tente novamente mais tarde.',
      button: 'Entendido'
    }
  }
}
